const AllGeneList = [
"A2ML1",
"AAAS",
"AACS",
"AAGAB",
"AARS",
"AARSD1",
"AATF",
"ABAT",
"ABCA11P",
"ABCA3",
"ABCA5",
"ABCB10",
"ABCB7",
"ABCB9",
"ABCC1",
"ABCC3",
"ABCC4",
"ABCC5",
"ABCD3",
"ABHD12",
"ABHD14B",
"ABHD2",
"ABHD3",
"ABI2",
"ABL1",
"ABL2",
"ABLIM1",
"ABR",
"ABTB2",
"ACAA1",
"ACACA",
"ACACB",
"ACAD10",
"ACAD9",
"ACADM",
"ACADS",
"ACAP2",
"ACBD3",
"ACBD5",
"ACBD6",
"ACER2",
"ACER3",
"ACIN1",
"ACLY",
"ACO1",
"ACOT7",
"ACOT8",
"ACOT9",
"ACOX1",
"ACOX3",
"ACPL2",
"ACSF3",
"ACSL1",
"ACSL3",
"ACSS1",
"ACSS3",
"ACTB",
"ACTG1",
"ACTN1",
"ACTN4",
"ACTR10",
"ACTR1A",
"ACTR1B",
"ACTR2",
"ACTR3",
"ACTR3B",
"ACTR3C",
"ACTR6",
"ACTR8",
"ACVR1",
"ACVR1B",
"ACVR2A",
"ADA",
"ADAL",
"ADAM10",
"ADAM17",
"ADAM22",
"ADAM32",
"ADAM9",
"ADAMTS17",
"ADAMTS19",
"ADAMTS6",
"ADAP1",
"ADAR",
"ADARB1",
"ADAT1",
"ADCK3",
"ADCK4",
"ADCY1",
"ADCY3",
"ADCY7",
"ADCY9",
"ADD1",
"ADD3",
"ADI1",
"ADIPOR2",
"ADK",
"ADNP",
"ADPGK",
"ADRBK1",
"ADRBK2",
"ADRM1",
"ADSS",
"AEBP2",
"AEN",
"AES",
"AFAP1",
"AFF1",
"AFF2",
"AFF4",
"AFG3L1P",
"AFG3L2",
"AFMID",
"AFTPH",
"AGAP1",
"AGAP3",
"AGBL5",
"AGFG1",
"AGGF1",
"AGK",
"AGL",
"AGPAT3",
"AGPAT5",
"AGPAT6",
"AGRN",
"AGTPBP1",
"AGXT2L2",
"AHCTF1",
"AHCY",
"AHCYL1",
"AHCYL2",
"AHI1",
"AHNAK",
"AHNAK2",
"AHRR",
"AHSA1",
"AIF1L",
"AIM1",
"AIMP1",
"AIMP2",
"AIP",
"AK2",
"AK3",
"AK4",
"AKAP1",
"AKAP10",
"AKAP11",
"AKAP13",
"AKAP9",
"AKR1A1",
"AKR1E2",
"AKT1",
"AKT2",
"AKT3",
"AKTIP",
"ALAS1",
"ALDH16A1",
"ALDH18A1",
"ALDH1A3",
"ALDH2",
"ALDH3A2",
"ALDH3B1",
"ALDH5A1",
"ALDH7A1",
"ALDH9A1",
"ALG13",
"ALG3",
"ALG5",
"ALG8",
"ALG9",
"ALK",
"ALKBH3",
"ALKBH5",
"ALKBH8",
"ALMS1",
"ALPK1",
"ALS2",
"ALS2CR8",
"AMBRA1",
"AMD1",
"AMFR",
"AMMECR1",
"AMMECR1L",
"AMOTL1",
"AMY2B",
"ANAPC1",
"ANAPC10",
"ANAPC4",
"ANAPC5",
"ANAPC7",
"ANGEL1",
"ANK3",
"ANKAR",
"ANKFY1",
"ANKH",
"ANKHD1-EIF4EBP3",
"ANKIB1",
"ANKLE2",
"ANKMY1",
"ANKMY2",
"ANKRD10",
"ANKRD11",
"ANKRD12",
"ANKRD13A",
"ANKRD13C",
"ANKRD17",
"ANKRD18B",
"ANKRD26",
"ANKRD27",
"ANKRD28",
"ANKRD32",
"ANKRD40",
"ANKRD42",
"ANKRD44",
"ANKRD46",
"ANKRD52",
"ANKS1A",
"ANKS1B",
"ANKS6",
"ANLN",
"ANO10",
"ANO6",
"ANP32B",
"ANP32E",
"ANPEP",
"ANTXR1",
"ANXA2",
"ANXA2P2",
"ANXA4",
"ANXA5",
"ANXA9",
"AP1B1",
"AP1G1",
"AP1M2",
"AP1S3",
"AP2A1",
"AP2A2",
"AP2B1",
"AP2M1",
"AP3B1",
"AP3D1",
"AP3S2",
"AP4B1",
"AP4E1",
"APAF1",
"APBB2",
"APC",
"APEH",
"API5",
"APITD1",
"APLF",
"APLP2",
"APOA1BP",
"APOPT1",
"APP",
"APPBP2",
"APPL1",
"AQR",
"ARAP2",
"ARCN1",
"ARF1",
"ARF3",
"ARF4",
"ARFGAP2",
"ARFGAP3",
"ARFGEF1",
"ARFGEF2",
"ARFIP1",
"ARHGAP10",
"ARHGAP11A",
"ARHGAP11B",
"ARHGAP12",
"ARHGAP17",
"ARHGAP19",
"ARHGAP21",
"ARHGAP26",
"ARHGAP29",
"ARHGAP32",
"ARHGAP35",
"ARHGAP39",
"ARHGAP5",
"ARHGAP8",
"ARHGDIA",
"ARHGEF10",
"ARHGEF10L",
"ARHGEF11",
"ARHGEF12",
"ARHGEF17",
"ARHGEF18",
"ARHGEF19",
"ARHGEF2",
"ARHGEF26",
"ARHGEF4",
"ARHGEF7",
"ARHGEF9",
"ARID1A",
"ARID1B",
"ARID2",
"ARID4A",
"ARID4B",
"ARID5B",
"ARIH1",
"ARIH2",
"ARL13B",
"ARL5A",
"ARL6IP1",
"ARL6IP6",
"ARL8B",
"ARMC1",
"ARMC6",
"ARMC8",
"ARMC9",
"ARNT",
"ARNT2",
"ARNTL2",
"ARPC1A",
"ARPC1B",
"ARPC2",
"ARPC4-TTLL3",
"ARPP19",
"ARRDC1",
"ARRDC3",
"ARSB",
"ARSD",
"ARSG",
"ASAP1",
"ASAP2",
"ASAP3",
"ASB1",
"ASB13",
"ASB3",
"ASB7",
"ASCC1",
"ASCC2",
"ASCC3",
"ASF1B",
"ASH1L",
"ASH2L",
"ASPH",
"ASPM",
"ASS1",
"ASTN2",
"ASXL1",
"ASXL2",
"ATAD1",
"ATAD2",
"ATAD2B",
"ATAD3B",
"ATAD5",
"ATE1",
"ATF1",
"ATF2",
"ATF4",
"ATF6",
"ATF7",
"ATF7IP2",
"ATG10",
"ATG13",
"ATG14",
"ATG16L1",
"ATG2A",
"ATG2B",
"ATG4B",
"ATG4C",
"ATG5",
"ATG7",
"ATIC",
"ATL2",
"ATL3",
"ATM",
"ATP11A",
"ATP11B",
"ATP11C",
"ATP13A1",
"ATP13A3",
"ATP1A1",
"ATP1B1",
"ATP1B3",
"ATP2A1",
"ATP2A2",
"ATP2A3",
"ATP2B1",
"ATP2B4",
"ATP2C1",
"ATP5A1",
"ATP5B",
"ATP5C1",
"ATP5D",
"ATP5F1",
"ATP5H",
"ATP5O",
"ATP5S",
"ATP6V0A1",
"ATP6V0A2",
"ATP6V0C",
"ATP6V0D1",
"ATP6V0E1",
"ATP6V1A",
"ATP6V1C1",
"ATP6V1D",
"ATP6V1F",
"ATP6V1H",
"ATP7A",
"ATP7B",
"ATP8A2",
"ATP8B1",
"ATP9A",
"ATP9B",
"ATPAF2",
"ATR",
"ATRIP",
"ATRN",
"ATRNL1",
"ATRX",
"ATXN1",
"ATXN10",
"ATXN1L",
"ATXN2",
"ATXN3",
"ATXN7",
"ATXN7L1",
"AUH",
"AUP1",
"AURKA",
"AURKB",
"AUTS2",
"AVL9",
"AVPI1",
"AXIN1",
"AXL",
"AZI1",
"AZI2",
"AZIN1",
"B3GALNT2",
"B3GNTL1",
"B4GALT1",
"B4GALT5",
"B4GALT6",
"BABAM1",
"BACE2",
"BACH1",
"BAG2",
"BAG4",
"BAGE2",
"BAHD1",
"BAI1",
"BAIAP2",
"BAIAP2L1",
"BANP",
"BARD1",
"BAX",
"BAZ1A",
"BAZ1B",
"BAZ2A",
"BAZ2B",
"BBS1",
"BBS4",
"BBS7",
"BBS9",
"BBX",
"BCAP29",
"BCAP31",
"BCAR1",
"BCAR3",
"BCAS1",
"BCAS3",
"BCAS4",
"BCKDHA",
"BCKDHB",
"BCL11B",
"BCL2L12",
"BCL2L13",
"BCL2L2",
"BCL7A",
"BCL9",
"BCR",
"BDAG1",
"BDP1",
"BFAR",
"BHLHE40",
"BICD1",
"BIN1",
"BIN3",
"BIRC2",
"BIRC3",
"BIRC6",
"BIVM",
"BIVM-ERCC5",
"BLCAP",
"BLM",
"BLVRB",
"BMI1",
"BMP1",
"BMP2K",
"BMP7",
"BMPR1A",
"BMPR1B",
"BMPR2",
"BMS1P4",
"BNIP2",
"BNIP3",
"BNIP3L",
"BNIPL",
"BOK",
"BOLA2",
"BOP1",
"BPTF",
"BRAF",
"BRAP",
"BRCA1",
"BRCA2",
"BRCC3",
"BRD1",
"BRD3",
"BRD4",
"BRD7",
"BRD9",
"BRE",
"BRF1",
"BRF2",
"BRIP1",
"BRIX1",
"BRK1",
"BROX",
"BRPF3",
"BRWD1",
"BRWD3",
"BTAF1",
"BTBD1",
"BTBD10",
"BTBD11",
"BTBD3",
"BTBD7",
"BTBD9",
"BTN2A2",
"BTRC",
"BUB1",
"BUB1B",
"BUD13",
"BZW1",
"BZW2",
"C10orf137",
"C10orf28",
"C10orf46",
"C10orf47",
"C10orf76",
"C11orf2",
"C11orf30",
"C11orf49",
"C11orf73",
"C11orf80",
"C11orf82",
"C11orf84",
"C12orf11",
"C12orf24",
"C12orf32",
"C12orf4",
"C12orf45",
"C12orf48",
"C12orf51",
"C12orf66",
"C14orf101",
"C14orf102",
"C14orf118",
"C14orf133",
"C14orf135",
"C14orf2",
"C14orf43",
"C15orf41",
"C15orf42",
"C16orf61",
"C16orf62",
"C16orf70",
"C16orf74",
"C17orf101",
"C17orf53",
"C17orf57",
"C17orf58",
"C17orf80",
"C17orf81",
"C17orf85",
"C18orf1",
"C18orf25",
"C18orf8",
"C19orf21",
"C19orf25",
"C19orf29",
"C19orf42",
"C19orf43",
"C19orf44",
"C19orf48",
"C1GALT1",
"C1orf101",
"C1orf112",
"C1orf124",
"C1orf135",
"C1orf151-NBL1",
"C1orf27",
"C1orf50",
"C1orf55",
"C1orf86",
"C1orf9",
"C20orf112",
"C20orf194",
"C20orf196",
"C20orf20",
"C20orf24",
"C20orf3",
"C20orf43",
"C20orf94",
"C21orf58",
"C21orf63",
"C22orf13",
"C22orf25",
"C22orf40",
"C2CD2",
"C2CD3",
"C2orf15",
"C2orf27A",
"C2orf28",
"C2orf29",
"C2orf42",
"C2orf43",
"C2orf48",
"C2orf56",
"C2orf67",
"C2orf74",
"C2orf89",
"C3",
"C3orf23",
"C3orf33",
"C3orf38",
"C3orf58",
"C3orf75",
"C4orf21",
"C4orf29",
"C4orf41",
"C5orf22",
"C5orf24",
"C5orf25",
"C5orf32",
"C5orf34",
"C5orf41",
"C5orf42",
"C6orf106",
"C6orf170",
"C6orf211",
"C6orf62",
"C6orf64",
"C6orf70",
"C6orf72",
"C6orf89",
"C7orf26",
"C7orf42",
"C7orf44",
"C8orf38",
"C8orf44-SGK3",
"C8orf76",
"C8orf83",
"C9orf102",
"C9orf16",
"C9orf174",
"C9orf3",
"C9orf30-TMEFF1",
"C9orf41",
"C9orf5",
"C9orf82",
"C9orf86",
"C9orf91",
"C9orf93",
"CAB39",
"CABIN1",
"CABLES1",
"CABLES2",
"CACNA1H",
"CACYBP",
"CAD",
"CADM1",
"CADPS2",
"CALD1",
"CALM2",
"CALM3",
"CALR",
"CAMK1D",
"CAMKK2",
"CAMKMT",
"CAMLG",
"CAMSAP1",
"CAMSAP2",
"CAMTA1",
"CAND1",
"CANT1",
"CANX",
"CAP1",
"CAP2",
"CAPG",
"CAPN1",
"CAPN2",
"CAPN7",
"CAPN8",
"CAPNS1",
"CAPRIN1",
"CAPRIN2",
"CAPZA1",
"CAPZB",
"CARD10",
"CARD8",
"CARHSP1",
"CARKD",
"CARM1",
"CARS2",
"CASC3",
"CASC4",
"CASC5",
"CASD1",
"CASK",
"CASP8AP2",
"CATSPERB",
"CBFA2T2",
"CBFB",
"CBL",
"CBLB",
"CBLC",
"CBLL1",
"CBR4",
"CBX1",
"CBX4",
"CBX5",
"CBX6",
"CC2D1A",
"CCAR1",
"CCBL2",
"CCDC109B",
"CCDC111",
"CCDC117",
"CCDC124",
"CCDC125",
"CCDC126",
"CCDC132",
"CCDC134",
"CCDC138",
"CCDC165",
"CCDC18",
"CCDC40",
"CCDC41",
"CCDC47",
"CCDC50",
"CCDC53",
"CCDC57",
"CCDC58",
"CCDC6",
"CCDC62",
"CCDC66",
"CCDC7",
"CCDC77",
"CCDC84",
"CCDC85C",
"CCDC88A",
"CCDC88C",
"CCDC9",
"CCDC90B",
"CCDC91",
"CCDC94",
"CCDC99",
"CCM2",
"CCNB1",
"CCNB1IP1",
"CCNB2",
"CCND1",
"CCNE2",
"CCNF",
"CCNH",
"CCNI",
"CCNL2",
"CCNT1",
"CCNT2",
"CCNY",
"CCNYL1",
"CCRN4L",
"CCS",
"CCT2",
"CCT3",
"CCT4",
"CCT6A",
"CCT7",
"CCT8",
"CD109",
"CD163L1",
"CD164",
"CD226",
"CD276",
"CD2AP",
"CD44",
"CD47",
"CD55",
"CD58",
"CD97",
"CD99L2",
"CDAN1",
"CDC123",
"CDC14A",
"CDC14B",
"CDC16",
"CDC20",
"CDC25A",
"CDC25B",
"CDC25C",
"CDC27",
"CDC37",
"CDC42",
"CDC42BPA",
"CDC42BPB",
"CDC42SE1",
"CDC45",
"CDC5L",
"CDC6",
"CDC7",
"CDC73",
"CDCA2",
"CDCA5",
"CDCA7",
"CDCA8",
"CDCP1",
"CDH1",
"CDH13",
"CDH3",
"CDK10",
"CDK11A",
"CDK12",
"CDK13",
"CDK14",
"CDK16",
"CDK17",
"CDK19",
"CDK5RAP1",
"CDK5RAP2",
"CDK6",
"CDK7",
"CDK8",
"CDKAL1",
"CDKN2B-AS",
"CDON",
"CDR1",
"CDR2",
"CDR2L",
"CDS2",
"CDT1",
"CDV3",
"CDYL",
"CDYL2",
"CEACAM5",
"CEBPZ",
"CELF1",
"CELSR1",
"CENPC1",
"CENPF",
"CENPI",
"CENPJ",
"CENPL",
"CENPN",
"CENPT",
"CEP104",
"CEP112",
"CEP120",
"CEP128",
"CEP135",
"CEP152",
"CEP164",
"CEP170",
"CEP192",
"CEP250",
"CEP350",
"CEP57",
"CEP57L1",
"CEP70",
"CEP72",
"CEP76",
"CEP78",
"CEP85",
"CEP85L",
"CEP89",
"CEP95",
"CEPT1",
"CERCAM",
"CERS4",
"CERS5",
"CERS6",
"CES2",
"CFDP1",
"CFL1",
"CFLAR",
"CHAC1",
"CHAF1A",
"CHAF1B",
"CHCHD3",
"CHCHD4",
"CHCHD6",
"CHD1",
"CHD1L",
"CHD2",
"CHD3",
"CHD4",
"CHD6",
"CHD7",
"CHD8",
"CHD9",
"CHEK1",
"CHEK2",
"CHFR",
"CHIC1",
"CHID1",
"CHKA",
"CHM",
"CHMP1A",
"CHMP4A",
"CHMP4B",
"CHMP7",
"CHN1",
"CHPT1",
"CHST11",
"CHST15",
"CHSY1",
"CHTF18",
"CHURC1-FNTB",
"CIRBP",
"CIRH1A",
"CIT",
"CIZ1",
"CKAP2L",
"CKAP5",
"CLASP1",
"CLASP2",
"CLASRP",
"CLCC1",
"CLCN6",
"CLDN4",
"CLEC16A",
"CLINT1",
"CLIP1",
"CLIP2",
"CLIP3",
"CLIP4",
"CLK1",
"CLK2",
"CLN3",
"CLNS1A",
"CLOCK",
"CLPB",
"CLPX",
"CLSPN",
"CLSTN1",
"CLTB",
"CLTC",
"CLTCL1",
"CLUAP1",
"CMAS",
"CMC1",
"CMIP",
"CMPK1",
"CMTM3",
"CMTM4",
"CMTM7",
"CNIH",
"CNIH3",
"CNIH4",
"CNKSR3",
"CNN2",
"CNNM4",
"CNOT1",
"CNOT10",
"CNOT2",
"CNOT3",
"CNOT6",
"CNOT6L",
"CNOT7",
"CNOT8",
"CNPY3",
"CNST",
"CNTLN",
"CNTRL",
"CNTROB",
"COBL",
"COBLL1",
"COBRA1",
"COCH",
"COG1",
"COG2",
"COG3",
"COG5",
"COG7",
"COL12A1",
"COL4A2",
"COL4A3BP",
"COL4A5",
"COL4A6",
"COL5A1",
"COL6A1",
"COL7A1",
"COMMD1",
"COMTD1",
"COPA",
"COPB1",
"COPB2",
"COPG",
"COPS3",
"COPS4",
"COPS7A",
"COPZ1",
"COQ10B",
"COQ2",
"COQ3",
"COQ4",
"COQ5",
"COQ6",
"CORIN",
"CORO1C",
"COTL1",
"COX10",
"COX5A",
"COX7B",
"COX8A",
"CPD",
"CPEB2",
"CPEB3",
"CPEB4",
"CPNE1",
"CPNE2",
"CPNE3",
"CPSF2",
"CPSF3",
"CPSF3L",
"CPSF4",
"CPSF6",
"CPSF7",
"CPT1A",
"CRADD",
"CRAMP1L",
"CRAT",
"CRCP",
"CREB1",
"CREB3L2",
"CREBBP",
"CREBL2",
"CREM",
"CRIM1",
"CRISPLD2",
"CRK",
"CRKL",
"CRLS1",
"CROT",
"CRTAP",
"CRTC3",
"CRY1",
"CRY2",
"CRYL1",
"CRYM-AS1",
"CS",
"CSDA",
"CSDE1",
"CSE1L",
"CSGALNACT2",
"CSNK1A1",
"CSNK1D",
"CSNK1E",
"CSNK1G1",
"CSNK1G3",
"CSNK2A1",
"CSPP1",
"CSRNP2",
"CSRP1",
"CSRP2BP",
"CST3",
"CSTF3",
"CTAGE5",
"CTBP1",
"CTBP2",
"CTC1",
"CTCF",
"CTDP1",
"CTDSP1",
"CTDSPL",
"CTDSPL2",
"CTIF",
"CTNNA1",
"CTNNB1",
"CTNNBIP1",
"CTNND1",
"CTNND2",
"CTNS",
"CTPS",
"CTPS2",
"CTSC",
"CTSD",
"CTSL2",
"CTSZ",
"CTTN",
"CUEDC1",
"CUL1",
"CUL2",
"CUL3",
"CUL4A",
"CUL5",
"CUL7",
"CUL9",
"CUX1",
"CWC22",
"CWF19L1",
"CWF19L2",
"CXorf23",
"CYB5A",
"CYBASC3",
"CYFIP1",
"CYHR1",
"CYLD",
"CYP24A1",
"CYP26B1",
"CYP51A1",
"CYTH1",
"CYTH3",
"D2HGDH",
"DAAM1",
"DAB2IP",
"DAG1",
"DAGLB",
"DAK",
"DAP3",
"DARS",
"DARS2",
"DAZAP1",
"DAZAP2",
"DBF4",
"DBP",
"DBR1",
"DCAF10",
"DCAF11",
"DCAF13",
"DCAF15",
"DCAF16",
"DCAF17",
"DCAF4",
"DCAF5",
"DCAF6",
"DCAF7",
"DCAF8",
"DCAKD",
"DCBLD1",
"DCBLD2",
"DCLRE1C",
"DCP1A",
"DCP2",
"DCTD",
"DCTN2",
"DCTN4",
"DCTN6",
"DCTPP1",
"DCUN1D2",
"DCUN1D3",
"DCUN1D4",
"DDAH1",
"DDB1",
"DDB2",
"DDHD1",
"DDHD2",
"DDI2",
"DDX1",
"DDX11",
"DDX17",
"DDX19B",
"DDX21",
"DDX23",
"DDX26B",
"DDX27",
"DDX31",
"DDX3X",
"DDX42",
"DDX46",
"DDX50",
"DDX51",
"DDX54",
"DDX55",
"DDX56",
"DDX59",
"DDX6",
"DDX60L",
"DEAF1",
"DECR1",
"DEDD",
"DEF6",
"DEF8",
"DEK",
"DENND1A",
"DENND1B",
"DENND3",
"DENND4A",
"DENND4B",
"DENND4C",
"DENND5A",
"DENND5B",
"DEPDC1B",
"DEPDC5",
"DERA",
"DERL1",
"DERL2",
"DFFA",
"DGCR2",
"DGCR8",
"DGKD",
"DGKE",
"DGKH",
"DGUOK",
"DHCR24",
"DHCR7",
"DHDDS",
"DHPS",
"DHRS11",
"DHRS3",
"DHTKD1",
"DHX15",
"DHX29",
"DHX30",
"DHX33",
"DHX34",
"DHX35",
"DHX36",
"DHX37",
"DHX38",
"DHX40",
"DHX57",
"DHX8",
"DHX9",
"DIABLO",
"DIAPH1",
"DIAPH2",
"DIAPH3",
"DICER1",
"DIDO1",
"DIP2A",
"DIP2B",
"DIP2C",
"DIS3L",
"DIS3L2",
"DISC1",
"DISP1",
"DKC1",
"DLAT",
"DLC1",
"DLEU1",
"DLEU2",
"DLG1",
"DLG5",
"DLGAP4",
"DLGAP5",
"DMC1",
"DMKN",
"DMTF1",
"DMXL1",
"DMXL2",
"DNA2",
"DNAH1",
"DNAH14",
"DNAH5",
"DNAJA1",
"DNAJA3",
"DNAJB1",
"DNAJB12",
"DNAJB14",
"DNAJB6",
"DNAJC1",
"DNAJC10",
"DNAJC11",
"DNAJC13",
"DNAJC15",
"DNAJC16",
"DNAJC2",
"DNAJC3",
"DNAJC5",
"DNAJC6",
"DNAJC7",
"DNASE2",
"DNER",
"DNHD1",
"DNM1L",
"DNM2",
"DNMBP",
"DNMT1",
"DNMT3A",
"DNMT3B",
"DNTTIP2",
"DOCK1",
"DOCK10",
"DOCK11",
"DOCK2",
"DOCK4",
"DOCK5",
"DOCK6",
"DOCK7",
"DOCK8",
"DOCK9",
"DONSON",
"DOPEY1",
"DOPEY2",
"DOT1L",
"DPAGT1",
"DPF2",
"DPM1",
"DPP3",
"DPP7",
"DPP8",
"DPP9",
"DPY19L4",
"DPYD",
"DPYSL2",
"DRAM1",
"DROSHA",
"DSC3",
"DSCAM",
"DSCC1",
"DSCR3",
"DSG2",
"DSP",
"DST",
"DSTYK",
"DTL",
"DTNB",
"DTNBP1",
"DTWD1",
"DTWD2",
"DUS1L",
"DUS2L",
"DUSP1",
"DUSP11",
"DUSP12",
"DUSP16",
"DUSP4",
"DUSP5",
"DUSP7",
"DVL1",
"DYM",
"DYNC1H1",
"DYNC1I2",
"DYNC1LI1",
"DYNC1LI2",
"DYNC2H1",
"DYNLL2",
"DYRK1A",
"DYX1C1-CCPG1",
"DZIP3",
"E2F1",
"E2F2",
"E2F3",
"E2F5",
"EAF1",
"EAF2",
"EARS2",
"ECD",
"ECE1",
"ECH1",
"ECHDC1",
"ECHDC3",
"ECHS1",
"ECI1",
"ECSIT",
"ECT2",
"EDARADD",
"EDC3",
"EDC4",
"EDEM1",
"EDEM3",
"EEA1",
"EED",
"EEF1A1",
"EEF1B2",
"EEF1D",
"EEF1E1-MUTED",
"EEF2",
"EEF2K",
"EEFSEC",
"EEPD1",
"EFCAB11",
"EFCAB2",
"EFEMP1",
"EFHA1",
"EFHC1",
"EFHD1",
"EFR3A",
"EFTUD1",
"EFTUD2",
"EGLN1",
"EHBP1",
"EHD1",
"EHD2",
"EHMT1",
"EI24",
"EIF1AD",
"EIF2A",
"EIF2AK1",
"EIF2AK3",
"EIF2AK4",
"EIF2B1",
"EIF2B2",
"EIF2B3",
"EIF2B5",
"EIF2C1",
"EIF2C2",
"EIF2C3",
"EIF2C4",
"EIF2D",
"EIF2S1",
"EIF2S2",
"EIF2S3",
"EIF3A",
"EIF3B",
"EIF3D",
"EIF3E",
"EIF3H",
"EIF3I",
"EIF3K",
"EIF3L",
"EIF3M",
"EIF4A2",
"EIF4A3",
"EIF4B",
"EIF4E2",
"EIF4E3",
"EIF4EBP1",
"EIF4ENIF1",
"EIF4G1",
"EIF4G2",
"EIF4G3",
"EIF5",
"EIF5A",
"ELF1",
"ELF2",
"ELF3",
"ELF4",
"ELK4",
"ELL",
"ELL2",
"ELMO2",
"ELMOD2",
"ELMOD3",
"ELOVL5",
"ELP2",
"ELP3",
"EMB",
"EML1",
"EML3",
"EML4",
"EML5",
"EML6",
"EMP2",
"EMR2",
"ENAH",
"ENC1",
"ENG",
"ENGASE",
"ENO1",
"ENO3",
"ENOPH1",
"ENOSF1",
"ENPP1",
"ENSA",
"ENTPD4",
"ENTPD6",
"EP300",
"EP400",
"EP400NL",
"EPB41",
"EPB41L1",
"EPB41L2",
"EPB41L4A",
"EPB41L4B",
"EPB41L5",
"EPC1",
"EPC2",
"EPG5",
"EPHA2",
"EPHA4",
"EPHA7",
"EPHB2",
"EPHB4",
"EPHX1",
"EPHX2",
"EPN1",
"EPN2",
"EPRS",
"EPS15",
"EPS15L1",
"EPT1",
"ERAL1",
"ERBB2",
"ERBB2IP",
"ERBB3",
"ERBB4",
"ERC1",
"ERCC3",
"ERCC6",
"ERCC8",
"ERGIC1",
"ERGIC3",
"ERH",
"ERI3",
"ERICH1",
"ERLIN1",
"ERMP1",
"ERO1L",
"ERP44",
"ERRFI1",
"ESCO1",
"ESPL1",
"ESR1",
"ESRP1",
"ESRP2",
"ESYT1",
"ESYT2",
"ETF1",
"ETFA",
"ETNK1",
"ETS1",
"ETV5",
"ETV6",
"EVI5",
"EVL",
"EVPL",
"EWSR1",
"EXD2",
"EXO1",
"EXOC1",
"EXOC2",
"EXOC3",
"EXOC4",
"EXOC5",
"EXOC6",
"EXOC6B",
"EXOC7",
"EXOSC1",
"EXOSC10",
"EXOSC2",
"EXOSC7",
"EXOSC9",
"EXT1",
"EXT2",
"EXTL3",
"EYA3",
"EZH1",
"EZH2",
"EZR",
"F2RL1",
"FADS1",
"FADS2",
"FAF1",
"FAF2",
"FAIM",
"FAM105B",
"FAM108B1",
"FAM108C1",
"FAM114A2",
"FAM116A",
"FAM117B",
"FAM118A",
"FAM120A",
"FAM120B",
"FAM120C",
"FAM125B",
"FAM126A",
"FAM126B",
"FAM129A",
"FAM129B",
"FAM134C",
"FAM135A",
"FAM136A",
"FAM13A",
"FAM13B",
"FAM160A1",
"FAM160A2",
"FAM160B1",
"FAM160B2",
"FAM168A",
"FAM168B",
"FAM169A",
"FAM171B",
"FAM173B",
"FAM175A",
"FAM175B",
"FAM176A",
"FAM177A1",
"FAM178A",
"FAM179B",
"FAM185A",
"FAM188A",
"FAM18B1",
"FAM18B2",
"FAM190B",
"FAM192A",
"FAM193A",
"FAM193B",
"FAM207A",
"FAM208A",
"FAM208B",
"FAM20B",
"FAM20C",
"FAM210A",
"FAM212B",
"FAM214A",
"FAM24B",
"FAM35A",
"FAM45B",
"FAM48A",
"FAM49B",
"FAM53A",
"FAM53B",
"FAM54A",
"FAM57A",
"FAM58A",
"FAM59A",
"FAM63B",
"FAM73A",
"FAM82A1",
"FAM82A2",
"FAM82B",
"FAM83A",
"FAM83D",
"FAM83H",
"FAM91A1",
"FAM98B",
"FAN1",
"FANCA",
"FANCB",
"FANCC",
"FANCD2",
"FANCG",
"FANCI",
"FANCL",
"FANCM",
"FAR1",
"FAR2",
"FARP1",
"FARP2",
"FARS2",
"FARSA",
"FARSB",
"FASN",
"FASTKD1",
"FAT1",
"FBLIM1",
"FBN1",
"FBRS",
"FBRSL1",
"FBXL13",
"FBXL17",
"FBXL18",
"FBXL19",
"FBXL3",
"FBXL4",
"FBXL5",
"FBXO10",
"FBXO11",
"FBXO18",
"FBXO21",
"FBXO22",
"FBXO24",
"FBXO33",
"FBXO34",
"FBXO38",
"FBXO4",
"FBXO42",
"FBXO7",
"FBXO9",
"FBXW11",
"FBXW2",
"FBXW4",
"FBXW5",
"FBXW7",
"FBXW8",
"FCHO1",
"FCHO2",
"FCHSD2",
"FDPS",
"FECH",
"FEM1C",
"FER",
"FER1L4",
"FERMT1",
"FERMT2",
"FGD1",
"FGD3",
"FGD4",
"FGD6",
"FGFR1OP",
"FGFR2",
"FGGY",
"FH",
"FHIT",
"FHOD3",
"FIG4",
"FIP1L1",
"FIS1",
"FKBP15",
"FKBP5",
"FKBP8",
"FKTN",
"FLCN",
"FLII",
"FLJ31306",
"FLJ33630",
"FLJ39534",
"FLJ43663",
"FLNA",
"FLNB",
"FLOT2",
"FLVCR1",
"FLVCR2",
"FLYWCH2",
"FMN1",
"FMNL2",
"FMNL3",
"FN1",
"FNBP1",
"FNBP1L",
"FNBP4",
"FNDC3A",
"FNDC3B",
"FNIP1",
"FNTA",
"FOPNL",
"FOXJ2",
"FOXJ3",
"FOXK1",
"FOXK2",
"FOXM1",
"FOXN2",
"FOXN3",
"FOXO1",
"FOXO3B",
"FOXP1",
"FOXP4",
"FOXRED2",
"FPGS",
"FRAS1",
"FREM2",
"FRMD4A",
"FRMD6",
"FRMD8",
"FRS2",
"FRYL",
"FSCN1",
"FSD1L",
"FTO",
"FTSJ3",
"FTSJD2",
"FUBP1",
"FUBP3",
"FUK",
"FUNDC1",
"FUT10",
"FUT8",
"FXN",
"FXR1",
"FYB",
"FYTTD1",
"FZD3",
"G2E3",
"G3BP1",
"G3BP2",
"G6PD",
"GAB1",
"GAB2",
"GABARAP",
"GABPA",
"GABPB1",
"GABPB2",
"GABRE",
"GADD45GIP1",
"GAK",
"GALC",
"GALK2",
"GALNS",
"GALNT1",
"GALNT10",
"GALNT2",
"GALNT3",
"GALNT6",
"GALNT7",
"GALNTL4",
"GAN",
"GANAB",
"GAPVD1",
"GARNL3",
"GARS",
"GART",
"GAS2L3",
"GAS5",
"GAS6",
"GATAD2A",
"GATAD2B",
"GATSL2",
"GBA",
"GBAS",
"GBE1",
"GBF1",
"GCAT",
"GCC2",
"GCFC1",
"GCFC2",
"GCH1",
"GCLC",
"GCLM",
"GCN1L1",
"GCNT1",
"GCSH",
"GDAP2",
"GDF15",
"GDI1",
"GDI2",
"GDPD3",
"GEMIN4",
"GEMIN5",
"GEN1",
"GFM1",
"GFM2",
"GFPT1",
"GFPT2",
"GFRA1",
"GGA1",
"GGA3",
"GGCX",
"GGNBP2",
"GIGYF2",
"GIN1",
"GINS1",
"GIPC1",
"GIT1",
"GIT2",
"GJB3",
"GK5",
"GKAP1",
"GLB1",
"GLCCI1",
"GLE1",
"GLG1",
"GLI1",
"GLI3",
"GLIS2",
"GLIS3",
"GLMN",
"GLOD4",
"GLRX3",
"GLRX5",
"GLS",
"GLT25D1",
"GLTPD1",
"GLUD1",
"GLYR1",
"GMDS",
"GMEB1",
"GMFB",
"GMIP",
"GMPR2",
"GMPS",
"GNA12",
"GNA14",
"GNAI1",
"GNAI3",
"GNAQ",
"GNAZ",
"GNB1",
"GNB2L1",
"GNB4",
"GNB5",
"GNL2",
"GNL3L",
"GNPNAT1",
"GNPTAB",
"GNPTG",
"GNS",
"GOLGA1",
"GOLGA3",
"GOLGA4",
"GOLGA5",
"GOLGB1",
"GOLIM4",
"GOLM1",
"GOLPH3",
"GOLPH3L",
"GON4L",
"GOPC",
"GORAB",
"GORASP2",
"GOSR1",
"GOT2",
"GPATCH1",
"GPATCH2",
"GPATCH3",
"GPATCH8",
"GPBP1",
"GPBP1L1",
"GPD1L",
"GPD2",
"GPHN",
"GPI",
"GPLD1",
"GPN3",
"GPR107",
"GPR125",
"GPR126",
"GPR137B",
"GPR137C",
"GPR153",
"GPR98",
"GPRC5A",
"GPRC5C",
"GPS1",
"GPSM2",
"GPT2",
"GRAMD1A",
"GRAMD4",
"GRB10",
"GRB2",
"GREB1",
"GREB1L",
"GRHL1",
"GRHL2",
"GRHPR",
"GRIK2",
"GRINA",
"GRIP1",
"GRM4",
"GRN",
"GRPEL1",
"GRSF1",
"GRTP1",
"GSK3B",
"GSPT1",
"GSR",
"GSTCD",
"GTDC1",
"GTF2A1",
"GTF2E1",
"GTF2E2",
"GTF2F1",
"GTF2F2",
"GTF2H1",
"GTF2I",
"GTF2IRD1",
"GTF3A",
"GTF3C1",
"GTF3C2",
"GTF3C3",
"GTF3C4",
"GTF3C5",
"GTPBP1",
"GTPBP10",
"GTPBP2",
"GTPBP4",
"GTPBP5",
"GTSE1",
"GUCY1B2",
"GUF1",
"GUSBP11",
"GXYLT1",
"GYG1",
"H2AFV",
"H2AFY",
"H6PD",
"HABP4",
"HACE1",
"HACL1",
"HADHA",
"HADHB",
"HAGH",
"HARS",
"HAS2",
"HAT1",
"HAUS1",
"HAUS4",
"HAUS6",
"HAUS8",
"HBP1",
"HBS1L",
"HCFC1",
"HCFC2",
"HDAC1",
"HDAC3",
"HDAC4",
"HDAC5",
"HDAC7",
"HDAC8",
"HDAC9",
"HDDC2",
"HDGF",
"HDGFRP2",
"HDGFRP3",
"HDHD2",
"HDLBP",
"HEATR1",
"HEATR2",
"HEATR3",
"HEATR5A",
"HEATR5B",
"HEATR6",
"HEATR7A",
"HEATR8-TTC4",
"HECA",
"HECTD1",
"HECTD2",
"HECW2",
"HELB",
"HELLS",
"HELQ",
"HELZ",
"HERC1",
"HERC2",
"HERC3",
"HERC4",
"HERPUD1",
"HERPUD2",
"HEXA",
"HEXDC",
"HGS",
"HHAT",
"HIAT1",
"HIATL1",
"HIATL2",
"HIBADH",
"HIBCH",
"HIC2",
"HIF1A",
"HINFP",
"HIP1",
"HIPK1",
"HIPK2",
"HIPK3",
"HIRA",
"HIST1H1D",
"HIST1H3D",
"HIVEP1",
"HIVEP3",
"HK1",
"HK2",
"HLCS",
"HM13",
"HMBOX1",
"HMCN1",
"HMG20A",
"HMGA1",
"HMGB3",
"HMGCL",
"HMGCR",
"HMGCS1",
"HMGXB3",
"HMMR",
"HN1",
"HN1L",
"HNRNPA2B1",
"HNRNPC",
"HNRNPD",
"HNRNPF",
"HNRNPH1",
"HNRNPH3",
"HNRNPK",
"HNRNPL",
"HNRNPM",
"HNRNPR",
"HNRNPU",
"HNRNPUL1",
"HNRNPUL2",
"HNRPLL",
"HOMER1",
"HOMER3",
"HOOK3",
"HP1BP3",
"HPCAL1",
"HPRT1",
"HPS4",
"HPS5",
"HSCB",
"HSD17B12",
"HSDL2",
"HSF1",
"HSF2BP",
"HSP90AA1",
"HSP90AB1",
"HSP90B1",
"HSPA14",
"HSPA4",
"HSPA4L",
"HSPA5",
"HSPA8",
"HSPA9",
"HSPB1",
"HSPD1",
"HSPE1",
"HSPE1-MOB4",
"HSPG2",
"HSPH1",
"HTR7",
"HTRA1",
"HTT",
"HUWE1",
"HYAL3",
"HYOU1",
"IARS",
"IARS2",
"IBTK",
"ICA1",
"ICAM1",
"ICMT",
"ICT1",
"IDE",
"IDH3A",
"IDS",
"IFI30",
"IFNAR1",
"IFNAR2",
"IFNGR2",
"IFRD2",
"IFT122",
"IFT140",
"IFT172",
"IFT43",
"IFT46",
"IFT80",
"IFT88",
"IGF1R",
"IGF2BP1",
"IGF2BP2",
"IGF2R",
"IGHMBP2",
"IGSF1",
"IGSF3",
"IGSF9",
"IKBKB",
"IKBKG",
"IKZF2",
"IL13RA1",
"IL15RA",
"IL1R1",
"IL1RAP",
"IL1RN",
"IL20RB",
"IL27RA",
"IL4R",
"IL6ST",
"ILF2",
"ILF3",
"ILK",
"ILKAP",
"ILVBL",
"IMMP1L",
"IMMP2L",
"IMMT",
"IMPACT",
"INADL",
"INCENP",
"INF2",
"ING5",
"INMT-FAM188B",
"INO80",
"INO80C",
"INO80D",
"INPP4A",
"INPP4B",
"INPP5A",
"INPP5B",
"INPPL1",
"INSIG1",
"INSR",
"INTS10",
"INTS12",
"INTS2",
"INTS3",
"INTS4",
"INTS5",
"INTS6",
"INTS7",
"INTS8",
"INTS9",
"INTU",
"INVS",
"IP6K2",
"IPO11",
"IPO7",
"IPO8",
"IPO9",
"IQCB1",
"IQCK",
"IQGAP1",
"IQGAP3",
"IQSEC1",
"IRAK1",
"IREB2",
"IRF6",
"ISG15",
"ISG20L2",
"ISOC1",
"ISPD",
"IST1",
"ITCH",
"ITFG1",
"ITFG2",
"ITFG3",
"ITGA3",
"ITGA6",
"ITGAV",
"ITGB1",
"ITGB3BP",
"ITGB4",
"ITGB5",
"ITGB6",
"ITGB8",
"ITM2B",
"ITPA",
"ITPK1",
"ITPKC",
"ITPR2",
"ITPR3",
"ITSN1",
"ITSN2",
"IWS1",
"JAG1",
"JAK2",
"JARID2",
"JDP2",
"JHDM1D",
"JKAMP",
"JMJD1C",
"JMJD5",
"JPH2",
"JRK",
"JUP",
"KAL1",
"KANK1",
"KANK2",
"KANSL2",
"KANSL3",
"KARS",
"KAT6A",
"KAT6B",
"KAT7",
"KATNA1",
"KATNAL1",
"KBTBD8",
"KCMF1",
"KCNMB4",
"KCNN2",
"KCNQ5",
"KCTD10",
"KCTD13",
"KCTD3",
"KCTD7",
"KDELR2",
"KDM1A",
"KDM1B",
"KDM2A",
"KDM2B",
"KDM3A",
"KDM3B",
"KDM4A",
"KDM4B",
"KDM4C",
"KDM5A",
"KDM5B",
"KDM5C",
"KDM6A",
"KDM6B",
"KDSR",
"KEAP1",
"KHDRBS1",
"KHSRP",
"KIAA0020",
"KIAA0090",
"KIAA0100",
"KIAA0101",
"KIAA0146",
"KIAA0182",
"KIAA0195",
"KIAA0196",
"KIAA0232",
"KIAA0240",
"KIAA0247",
"KIAA0317",
"KIAA0319L",
"KIAA0355",
"KIAA0368",
"KIAA0494",
"KIAA0513",
"KIAA0528",
"KIAA0556",
"KIAA0564",
"KIAA0586",
"KIAA0664",
"KIAA0753",
"KIAA0825",
"KIAA0889",
"KIAA0907",
"KIAA0922",
"KIAA0930",
"KIAA0947",
"KIAA1009",
"KIAA1033",
"KIAA1109",
"KIAA1191",
"KIAA1211",
"KIAA1217",
"KIAA1244",
"KIAA1328",
"KIAA1429",
"KIAA1430",
"KIAA1432",
"KIAA1468",
"KIAA1524",
"KIAA1549",
"KIAA1586",
"KIAA1598",
"KIAA1609",
"KIAA1704",
"KIAA1715",
"KIAA1731",
"KIAA1797",
"KIAA1804",
"KIAA1841",
"KIAA1919",
"KIAA1958",
"KIAA1967",
"KIAA1984",
"KIAA2018",
"KIDINS220",
"KIF11",
"KIF13A",
"KIF13B",
"KIF14",
"KIF15",
"KIF16B",
"KIF18A",
"KIF18B",
"KIF1B",
"KIF1C",
"KIF20B",
"KIF21A",
"KIF22",
"KIF23",
"KIF24",
"KIF2A",
"KIF2C",
"KIF3B",
"KIF4A",
"KIF5B",
"KIF9",
"KIFAP3",
"KIFC3",
"KITLG",
"KLC1",
"KLF12",
"KLF6",
"KLF7",
"KLHDC10",
"KLHDC2",
"KLHDC4",
"KLHL12",
"KLHL13",
"KLHL18",
"KLHL2",
"KLHL20",
"KLHL21",
"KLHL22",
"KLHL24",
"KLHL28",
"KLHL5",
"KLHL7",
"KLHL8",
"KNTC1",
"KPNA1",
"KPNA3",
"KPNA4",
"KPNA5",
"KPNA6",
"KPNB1",
"KRIT1",
"KRT16",
"KRT19",
"KRT5",
"KRT6A",
"KRT7",
"KRT8",
"KRT80",
"KRT81",
"KTN1",
"KXD1",
"KYNU",
"L1CAM",
"L2HGDH",
"L3MBTL2",
"LAMA3",
"LAMA5",
"LAMB1",
"LAMB2",
"LAMB3",
"LAMC1",
"LAMC2",
"LAMP1",
"LANCL1",
"LAPTM4B",
"LARGE",
"LARP1",
"LARP1B",
"LARP4",
"LARP4B",
"LARP7",
"LARS",
"LAS1L",
"LASP1",
"LATS1",
"LATS2",
"LBR",
"LCAT",
"LCLAT1",
"LCMT1",
"LCOR",
"LDHA",
"LDLR",
"LDLRAD3",
"LEMD2",
"LEPREL4",
"LEPROTL1",
"LETM1",
"LETMD1",
"LGALS1",
"LGMN",
"LHFPL2",
"LIFR",
"LIG1",
"LIG3",
"LIMD1",
"LIMK2",
"LIMS1",
"LIN54",
"LIN9",
"LINC00152",
"LINC00158",
"LINC00340",
"LINC00473",
"LIPH",
"LITAF",
"LLGL2",
"LMAN1",
"LMAN2",
"LMBR1",
"LMBR1L",
"LMBRD2",
"LMF1",
"LMLN",
"LMNA",
"LMNB1",
"LMNB2",
"LMO7",
"LMTK2",
"LNPEP",
"LNX2",
"LOC100130950",
"LOC100131234",
"LOC100131564",
"LOC100133315",
"LOC100190939",
"LOC100272228",
"LOC100287765",
"LOC100288637",
"LOC100289561",
"LOC100505549",
"LOC100506033",
"LOC100506866",
"LOC100507127",
"LOC100507246",
"LOC100507266",
"LOC100630923",
"LOC148696",
"LOC150381",
"LOC202181",
"LOC219347",
"LOC283922",
"LOC285033",
"LOC286467",
"LOC338799",
"LOC340037",
"LOC375190",
"LOC388796",
"LOC389831",
"LOC399815",
"LOC440944",
"LOC642852",
"LOC646851",
"LOC647946",
"LOC648691",
"LOC729852",
"LOC81691",
"LOC92249",
"LONP1",
"LONP2",
"LOXL1",
"LPAR1",
"LPAR3",
"LPCAT1",
"LPCAT2",
"LPGAT1",
"LPHN1",
"LPHN2",
"LPHN3",
"LPIN1",
"LPIN2",
"LPP",
"LRBA",
"LRCH1",
"LRCH3",
"LRIF1",
"LRIG1",
"LRIG2",
"LRP1",
"LRP10",
"LRP11",
"LRP1B",
"LRP4",
"LRP5",
"LRP5L",
"LRP6",
"LRP8",
"LRPPRC",
"LRRC14",
"LRRC16A",
"LRRC37B",
"LRRC40",
"LRRC41",
"LRRC42",
"LRRC47",
"LRRC58",
"LRRC8A",
"LRRC8B",
"LRRC8C",
"LRRCC1",
"LRRFIP2",
"LRRK1",
"LRSAM1",
"LRWD1",
"LSG1",
"LSM12",
"LSM14A",
"LSM14B",
"LSM4",
"LSM5",
"LSS",
"LTBP1",
"LTBR",
"LTN1",
"LUC7L",
"LUC7L2",
"LUC7L3",
"LUZP1",
"LY6E",
"LYN",
"LYPD3",
"LYPD6",
"LYPLA1",
"LYPLAL1",
"LYRM1",
"LYST",
"LZIC",
"MACC1",
"MACF1",
"MACROD1",
"MAD1L1",
"MADD",
"MAEA",
"MAF1",
"MAGED1",
"MAGI1",
"MAGI3",
"MAGT1",
"MAK16",
"MALAT1",
"MALT1",
"MAML1",
"MAML2",
"MAML3",
"MAN1A2",
"MAN1B1",
"MAN2A1",
"MANBA",
"MANBAL",
"MAP1B",
"MAP1LC3B",
"MAP1S",
"MAP2K1",
"MAP2K2",
"MAP2K4",
"MAP2K5",
"MAP3K1",
"MAP3K11",
"MAP3K13",
"MAP3K14",
"MAP3K3",
"MAP3K4",
"MAP3K5",
"MAP3K7",
"MAP3K9",
"MAP4",
"MAP4K3",
"MAP4K4",
"MAP4K5",
"MAP7",
"MAP7D1",
"MAPK1",
"MAPK14",
"MAPK1IP1L",
"MAPK4",
"MAPK6",
"MAPK8",
"MAPK8IP3",
"MAPK9",
"MAPKAP1",
"MAPKAPK2",
"MAPKAPK5",
"MAPKBP1",
"MARCKSL1",
"MARK1",
"MARK2",
"MARK3",
"MARK4",
"MARS",
"MARVELD2",
"MAST2",
"MAST3",
"MAST4",
"MASTL",
"MAT2A",
"MATR3",
"MAVS",
"MAZ",
"MB21D1",
"MBD2",
"MBD5",
"MBNL1",
"MBNL2",
"MBNL3",
"MBOAT1",
"MBOAT2",
"MBOAT7",
"MBTD1",
"MBTPS1",
"MBTPS2",
"MCC",
"MCCC1",
"MCCC2",
"MCF2L2",
"MCFD2",
"MCL1",
"MCM10",
"MCM2",
"MCM3",
"MCM3AP",
"MCM4",
"MCM5",
"MCM6",
"MCM7",
"MCM8",
"MCM9",
"MCMBP",
"MCPH1",
"MCTP1",
"MCTP2",
"MCU",
"MDFIC",
"MDH1",
"MDH2",
"MDM2",
"MDM4",
"MDN1",
"ME1",
"ME2",
"MECR",
"MED1",
"MED12L",
"MED13",
"MED13L",
"MED14",
"MED16",
"MED17",
"MED23",
"MED27",
"MED30",
"MED4",
"MED6",
"MEF2A",
"MEF2BNB-MEF2B",
"MEF2D",
"MEGF8",
"MEIS2",
"MEIS3",
"MELK",
"MEMO1",
"MESDC2",
"MET",
"METAP2",
"METRN",
"METTL10",
"METTL11A",
"METTL13",
"METTL15",
"METTL16",
"METTL22",
"METTL3",
"METTL4",
"METTL6",
"METTL8",
"METTL9",
"MFAP1",
"MFAP3",
"MFF",
"MFI2",
"MFN1",
"MFN2",
"MFSD11",
"MFSD12",
"MFSD2A",
"MFSD8",
"MGA",
"MGAT1",
"MGAT2",
"MGAT4A",
"MGAT5",
"MGEA5",
"MGLL",
"MGMT",
"MGRN1",
"MIA3",
"MIB1",
"MICAL3",
"MICALCL",
"MICALL1",
"MICU1",
"MID1",
"MID2",
"MIER2",
"MIER3",
"MINK1",
"MIOS",
"MIPEP",
"MIPOL1",
"MIRLET7BHG",
"MKI67",
"MKL1",
"MKL2",
"MKLN1",
"MKNK1",
"MLEC",
"MLF1IP",
"MLF2",
"MLH1",
"MLH3",
"MLL",
"MLL2",
"MLL3",
"MLL4",
"MLL5",
"MLLT1",
"MLLT10",
"MLLT3",
"MLLT4",
"MLLT6",
"MLPH",
"MMP15",
"MMP24",
"MMS22L",
"MNAT1",
"MND1",
"MNT",
"MOB1A",
"MOB1B",
"MOB2",
"MOB3A",
"MOCOS",
"MON2",
"MORC2",
"MORC3",
"MORF4L1",
"MPHOSPH10",
"MPHOSPH8",
"MPHOSPH9",
"MPP3",
"MPP5",
"MPP6",
"MPP7",
"MPPED2",
"MPRIP",
"MPZL1",
"MRC2",
"MRE11A",
"MREG",
"MRI1",
"MRPL18",
"MRPL2",
"MRPL30",
"MRPL35",
"MRPL37",
"MRPL38",
"MRPL4",
"MRPL47",
"MRPL48",
"MRPS27",
"MRPS31",
"MRPS35",
"MRPS6",
"MRRF",
"MRS2",
"MSH2",
"MSH3",
"MSH6",
"MSI2",
"MSN",
"MST1R",
"MST4",
"MTA1",
"MTA2",
"MTA3",
"MTBP",
"MTCH1",
"MTCH2",
"MTDH",
"MTERFD1",
"MTF1",
"MTF2",
"MTFR1",
"MTG1",
"MTHFD1",
"MTHFD1L",
"MTHFD2",
"MTHFD2L",
"MTHFS",
"MTHFSD",
"MTIF2",
"MTM1",
"MTMR1",
"MTMR10",
"MTMR12",
"MTMR14",
"MTMR3",
"MTMR4",
"MTMR6",
"MTMR9",
"MTO1",
"MTOR",
"MTPAP",
"MTR",
"MTRF1",
"MTRR",
"MTUS1",
"MUC16",
"MUDENG",
"MUM1",
"MUTED-TXNDC5",
"MVK",
"MYBBP1A",
"MYBL1",
"MYBL2",
"MYC",
"MYCBP2",
"MYH10",
"MYH14",
"MYH15",
"MYH3",
"MYH9",
"MYL6",
"MYL6B",
"MYO10",
"MYO18A",
"MYO19",
"MYO1B",
"MYO1C",
"MYO1D",
"MYO1E",
"MYO5A",
"MYO5B",
"MYO5C",
"MYO6",
"MYO9A",
"MYO9B",
"MYOF",
"MYPN",
"MYSM1",
"MZF1",
"N4BP1",
"N4BP2",
"N4BP2L2",
"N6AMT2",
"NAA10",
"NAA15",
"NAA16",
"NAA20",
"NAA25",
"NAA35",
"NAA38",
"NAA60",
"NAALADL2",
"NAB1",
"NACA",
"NACC1",
"NACC2",
"NADKD1",
"NADSYN1",
"NAE1",
"NAGLU",
"NAGPA",
"NALCN",
"NANS",
"NAP1L1",
"NAP1L4",
"NAPB",
"NAPEPLD",
"NAPG",
"NAPRT1",
"NARF",
"NARG2",
"NARS",
"NARS2",
"NASP",
"NAT10",
"NAV1",
"NAV2",
"NAV3",
"NBAS",
"NBEA",
"NBEAL1",
"NBEAL2",
"NBN",
"NBPF9",
"NBR1",
"NCAM2",
"NCAPD2",
"NCAPD3",
"NCAPG",
"NCAPG2",
"NCAPH",
"NCBP1",
"NCBP2",
"NCEH1",
"NCK1",
"NCKAP1",
"NCKIPSD",
"NCL",
"NCLN",
"NCOA1",
"NCOA2",
"NCOA3",
"NCOA4",
"NCOA6",
"NCOR1",
"NCOR2",
"NCSTN",
"NDEL1",
"NDFIP2",
"NDOR1",
"NDRG1",
"NDRG3",
"NDST1",
"NDUFA10",
"NDUFA12",
"NDUFA8",
"NDUFAB1",
"NDUFB2",
"NDUFS1",
"NDUFS3",
"NDUFS4",
"NDUFS5",
"NDUFS6",
"NDUFV2",
"NEBL",
"NECAP2",
"NEDD1",
"NEDD4",
"NEDD4L",
"NEDD9",
"NEIL3",
"NEK1",
"NEK11",
"NEK2",
"NEK4",
"NEK6",
"NEK7",
"NEK9",
"NEMF",
"NEO1",
"NETO2",
"NEURL4",
"NF1",
"NF2",
"NFAT5",
"NFATC1",
"NFATC2",
"NFATC3",
"NFE2L2",
"NFIB",
"NFIC",
"NFIX",
"NFKB1",
"NFKBID",
"NFRKB",
"NFU1",
"NFX1",
"NFXL1",
"NFYA",
"NFYB",
"NFYC",
"NHLRC2",
"NHS",
"NHSL1",
"NID2",
"NIF3L1",
"NIN",
"NINL",
"NIPA1",
"NIPA2",
"NIPAL2",
"NIPBL",
"NIPSNAP3A",
"NISCH",
"NKIRAS1",
"NKTR",
"NLE1",
"NLGN1",
"NLK",
"NLN",
"NLRX1",
"NMD3",
"NME7",
"NMNAT1",
"NMRAL1",
"NMT1",
"NMT2",
"NNT",
"NOC2L",
"NOD1",
"NOL10",
"NOL11",
"NOL8",
"NOL9",
"NOLC1",
"NOM1",
"NOMO1",
"NOMO2",
"None",
"NONO",
"NOP14",
"NOP2",
"NOP56",
"NOP58",
"NOTCH1",
"NOTCH2",
"NOTCH3",
"NPAS2",
"NPAT",
"NPC1",
"NPEPPS",
"NPHP3-ACAD11",
"NPHP4",
"NPLOC4",
"NPM1",
"NPRL2",
"NPRL3",
"NPTN",
"NQO1",
"NQO2",
"NR1D2",
"NR2C1",
"NR2C2",
"NR2F6",
"NR3C1",
"NR4A3",
"NR5A2",
"NR6A1",
"NRAS",
"NRBP1",
"NRCAM",
"NRD1",
"NRF1",
"NRIP1",
"NRP1",
"NSD1",
"NSDHL",
"NSFL1C",
"NSMAF",
"NSMCE1",
"NSMCE2",
"NSMCE4A",
"NSRP1",
"NSUN2",
"NSUN6",
"NT5C",
"NT5C2",
"NT5C3L",
"NT5DC1",
"NT5DC3",
"NTN4",
"NTNG1",
"NTRK2",
"NUBPL",
"NUCKS1",
"NUDC",
"NUDCD1",
"NUDCD3",
"NUDT14",
"NUDT19",
"NUDT2",
"NUDT5",
"NUDT9",
"NUMA1",
"NUMB",
"NUP107",
"NUP133",
"NUP153",
"NUP155",
"NUP160",
"NUP188",
"NUP205",
"NUP210",
"NUP210L",
"NUP214",
"NUP35",
"NUP37",
"NUP43",
"NUP50",
"NUP54",
"NUP62CL",
"NUP85",
"NUP88",
"NUP93",
"NUP98",
"NUPL1",
"NUPL2",
"NUSAP1",
"NVL",
"NXF1",
"NXN",
"OAT",
"OAZ1",
"OAZ2",
"OBSL1",
"OCIAD1",
"OCRL",
"ODF2",
"ODF2L",
"ODZ2",
"ODZ3",
"ODZ4",
"OFD1",
"OGDH",
"OGFOD1",
"OGFR",
"OGG1",
"OGT",
"OIP5",
"OIP5-AS1",
"OLA1",
"OLFM1",
"OLFM2",
"OMA1",
"OPA1",
"OPHN1",
"OPTN",
"ORAI1",
"ORC1",
"ORC2",
"ORC3",
"ORC4",
"ORC5",
"ORC6",
"OS9",
"OSBP",
"OSBPL10",
"OSBPL11",
"OSBPL1A",
"OSBPL2",
"OSBPL3",
"OSBPL8",
"OSBPL9",
"OSGIN2",
"OSMR",
"OTUD3",
"OTUD4",
"OTUD5",
"OTUD7B",
"OXCT1",
"OXNAD1",
"OXR1",
"OXSR1",
"P4HA1",
"P4HB",
"PAAF1",
"PABPC1",
"PACRGL",
"PACS1",
"PACS2",
"PACSIN2",
"PAFAH1B1",
"PAFAH1B2",
"PAICS",
"PAIP2",
"PAK1",
"PAK1IP1",
"PAK2",
"PALB2",
"PALLD",
"PALM2-AKAP2",
"PAM",
"PAN3",
"PANK1",
"PANK2",
"PANK3",
"PAPD4",
"PAPD5",
"PAPD7",
"PAPOLA",
"PAPOLG",
"PAPPA",
"PAPPA2",
"PAPSS1",
"PAQR7",
"PARD3",
"PARD3B",
"PARD6B",
"PARG",
"PARK7",
"PARL",
"PARN",
"PARP1",
"PARP12",
"PARP4",
"PARP6",
"PARP8",
"PARP9",
"PASK",
"PATL1",
"PAXIP1",
"PBLD",
"PBRM1",
"PBX1",
"PBX3",
"PBX4",
"PCBD2",
"PCBP1-AS1",
"PCBP2",
"PCCA",
"PCCB",
"PCDHGB6",
"PCF11",
"PCGF5",
"PCGF6",
"PCID2",
"PCLO",
"PCM1",
"PCMT1",
"PCMTD1",
"PCMTD2",
"PCNA",
"PCNP",
"PCNT",
"PCNX",
"PCNXL2",
"PCSK5",
"PCSK6",
"PCYT1A",
"PDCD10",
"PDCD11",
"PDCD4",
"PDCD6",
"PDCD6IP",
"PDE10A",
"PDE3A",
"PDE3B",
"PDE4A",
"PDE4B",
"PDE4D",
"PDE4DIP",
"PDE5A",
"PDE7A",
"PDE8A",
"PDE9A",
"PDGFRL",
"PDHX",
"PDIA3",
"PDIA4",
"PDIA5",
"PDIA6",
"PDK1",
"PDK3",
"PDLIM1",
"PDLIM5",
"PDLIM7",
"PDPK1",
"PDPR",
"PDS5A",
"PDS5B",
"PDSS1",
"PDSS2",
"PDXDC2P",
"PDXK",
"PEA15",
"PEAK1",
"PEG10",
"PELP1",
"PER2",
"PES1",
"PET117",
"PEX1",
"PEX13",
"PEX14",
"PEX5",
"PEX6",
"PFAS",
"PFDN2",
"PFDN5",
"PFKFB2",
"PFKFB3",
"PFKL",
"PFKP",
"PGAM5",
"PGAP1",
"PGAP3",
"PGD",
"PGK1",
"PGLS",
"PGM1",
"PGM3",
"PGPEP1",
"PGR",
"PGS1",
"PHACTR2",
"PHACTR4",
"PHAX",
"PHB2",
"PHC2",
"PHC3",
"PHF12",
"PHF13",
"PHF14",
"PHF17",
"PHF19",
"PHF2",
"PHF20",
"PHF20L1",
"PHF21A",
"PHF3",
"PHF5A",
"PHF6",
"PHF7",
"PHF8",
"PHGDH",
"PHIP",
"PHKB",
"PHKG1",
"PHLDB2",
"PHLPP1",
"PHLPP2",
"PHOSPHO2-KLHL23",
"PHRF1",
"PHTF1",
"PHTF2",
"PHYH",
"PI4K2A",
"PI4K2B",
"PI4KA",
"PI4KB",
"PIAS1",
"PIAS2",
"PIAS3",
"PIBF1",
"PICALM",
"PIEZO1",
"PIF1",
"PIGB",
"PIGF",
"PIGG",
"PIGK",
"PIGN",
"PIGU",
"PIH1D1",
"PIK3C2A",
"PIK3C2B",
"PIK3C3",
"PIK3CA",
"PIK3CB",
"PIK3R1",
"PIK3R3",
"PIK3R4",
"PIKFYVE",
"PILRB",
"PIN1",
"PINX1",
"PION",
"PIP5K1A",
"PIP5K1B",
"PIP5K1C",
"PIP5KL1",
"PISD",
"PITPNA",
"PITPNB",
"PITPNC1",
"PITPNM1",
"PITPNM2",
"PITRM1",
"PJA2",
"PKD2",
"PKM2",
"PKN2",
"PKNOX1",
"PKP1",
"PKP2",
"PKP4",
"PLA2G4A",
"PLAA",
"PLCB1",
"PLCB3",
"PLCB4",
"PLCD3",
"PLCE1",
"PLCG2",
"PLCH1",
"PLCL2",
"PLD1",
"PLD2",
"PLD5",
"PLEC",
"PLEKHA1",
"PLEKHA2",
"PLEKHA5",
"PLEKHA6",
"PLEKHA7",
"PLEKHB2",
"PLEKHF2",
"PLEKHG2",
"PLEKHG3",
"PLEKHH2",
"PLEKHM1P",
"PLEKHM2",
"PLEKHM3",
"PLIN2",
"PLK1",
"PLK3",
"PLK4",
"PLLP",
"PLOD1",
"PLOD2",
"PLS1",
"PLXNA1",
"PLXNA2",
"PLXNA3",
"PLXNB1",
"PLXNC1",
"PLXND1",
"PMEPA1",
"PMM1",
"PMM2",
"PMPCB",
"PMS1",
"PMS2",
"PMS2CL",
"PNISR",
"PNKD",
"PNLIPRP3",
"PNN",
"PNPLA6",
"PNPLA8",
"PNPT1",
"POC1A",
"POC1B",
"POC5",
"PODXL",
"POF1B",
"POFUT1",
"POFUT2",
"POGZ",
"POLA1",
"POLA2",
"POLB",
"POLD1",
"POLD3",
"POLD4",
"POLDIP2",
"POLDIP3",
"POLE",
"POLH",
"POLI",
"POLK",
"POLL",
"POLQ",
"POLR1A",
"POLR1B",
"POLR1E",
"POLR2A",
"POLR2B",
"POLR2E",
"POLR2I",
"POLR2J4",
"POLR3A",
"POLR3C",
"POLR3E",
"POLR3H",
"POM121",
"POM121C",
"POMT1",
"POMZP3",
"PON2",
"POP1",
"POTEF",
"POU2F1",
"PPA1",
"PPA2",
"PPAP2A",
"PPAP2B",
"PPAPDC1A",
"PPARG",
"PPARGC1B",
"PPAT",
"PPFIA1",
"PPFIA3",
"PPFIBP1",
"PPHLN1",
"PPIA",
"PPIB",
"PPIC",
"PPIF",
"PPIG",
"PPIL2",
"PPIL3",
"PPIL4",
"PPIP5K1",
"PPIP5K2",
"PPM1A",
"PPM1B",
"PPM1D",
"PPM1E",
"PPM1F",
"PPM1G",
"PPME1",
"PPP1CB",
"PPP1CC",
"PPP1R12A",
"PPP1R12B",
"PPP1R12C",
"PPP1R13B",
"PPP1R13L",
"PPP1R15A",
"PPP1R2",
"PPP1R21",
"PPP1R26",
"PPP1R37",
"PPP1R7",
"PPP1R8",
"PPP1R9A",
"PPP2CA",
"PPP2CB",
"PPP2R1A",
"PPP2R1B",
"PPP2R2A",
"PPP2R2C",
"PPP2R2D",
"PPP2R3A",
"PPP2R3C",
"PPP2R4",
"PPP2R5A",
"PPP2R5C",
"PPP2R5D",
"PPP2R5E",
"PPP3CA",
"PPP3CB",
"PPP3CC",
"PPP4R1",
"PPP4R1L",
"PPP5C",
"PPP6C",
"PPP6R1",
"PPP6R2",
"PPP6R3",
"PPPDE1",
"PPPDE2",
"PPRC1",
"PPT1",
"PPTC7",
"PPWD1",
"PQLC1",
"PRAF2",
"PRC1",
"PRCP",
"PRDM10",
"PRDM15",
"PRDM2",
"PRDM4",
"PRDM5",
"PRDX2",
"PRDX4",
"PRELID2",
"PREP",
"PREPL",
"PREX1",
"PRH1-PRR4",
"PRICKLE2",
"PRICKLE4",
"PRIM1",
"PRIM2",
"PRKAA1",
"PRKAB1",
"PRKACB",
"PRKAR1B",
"PRKAR2A",
"PRKCA",
"PRKCD",
"PRKCE",
"PRKCH",
"PRKCI",
"PRKCZ",
"PRKD1",
"PRKD2",
"PRKD3",
"PRKDC",
"PRMT1",
"PRMT10",
"PRMT2",
"PRMT3",
"PRMT5",
"PROSC",
"PROSER1",
"PRPF3",
"PRPF39",
"PRPF40A",
"PRPF4B",
"PRPF6",
"PRPF8",
"PRPS1",
"PRPS2",
"PRPSAP1",
"PRPSAP2",
"PRR11",
"PRR12",
"PRR13",
"PRR14",
"PRR14L",
"PRR24",
"PRR5-ARHGAP8",
"PRRC1",
"PRRC2B",
"PRRC2C",
"PRRG1",
"PRRG4",
"PRSS12",
"PRSS23",
"PRSS8",
"PRTFDC1",
"PRUNE",
"PSD3",
"PSD4",
"PSEN1",
"PSEN2",
"PSIP1",
"PSMA1",
"PSMA3",
"PSMA4",
"PSMA5",
"PSMA6",
"PSMA7",
"PSMB1",
"PSMB5",
"PSMB7",
"PSMC2",
"PSMC3",
"PSMC4",
"PSMD1",
"PSMD14",
"PSMD2",
"PSMD5",
"PSMD6",
"PSMD9",
"PSME4",
"PSMG2",
"PSPC1",
"PSTPIP2",
"PTAR1",
"PTBP1",
"PTBP2",
"PTBP3",
"PTCD3",
"PTDSS1",
"PTEN",
"PTER",
"PTGES3",
"PTGFRN",
"PTGR1",
"PTGR2",
"PTK2",
"PTK7",
"PTP4A2",
"PTPDC1",
"PTPLA",
"PTPLAD1",
"PTPLB",
"PTPN1",
"PTPN11",
"PTPN12",
"PTPN13",
"PTPN14",
"PTPN2",
"PTPN21",
"PTPN22",
"PTPN4",
"PTPN6",
"PTPN9",
"PTPRA",
"PTPRF",
"PTPRG",
"PTPRH",
"PTPRJ",
"PTPRK",
"PTPRM",
"PTPRN2",
"PTPRS",
"PTPRU",
"PTRF",
"PTRH2",
"PTTG1IP",
"PUM1",
"PUM2",
"PUS1",
"PUS10",
"PUS7",
"PUS7L",
"PVRL1",
"PVRL2",
"PVRL3",
"PVT1",
"PWWP2A",
"PXDN",
"PXN",
"PYCR1",
"PYCR2",
"PYGL",
"PYROXD2",
"QDPR",
"QKI",
"QRICH1",
"QRICH2",
"QSER1",
"QSOX1",
"QSOX2",
"QTRTD1",
"R3HDM1",
"R3HDM2",
"RAB10",
"RAB11FIP1",
"RAB11FIP3",
"RAB11FIP5",
"RAB12",
"RAB1A",
"RAB22A",
"RAB23",
"RAB25",
"RAB27A",
"RAB28",
"RAB2A",
"RAB2B",
"RAB31",
"RAB36",
"RAB3D",
"RAB3GAP1",
"RAB3GAP2",
"RAB3IP",
"RAB40C",
"RAB4B-EGLN2",
"RAB5A",
"RAB6A",
"RAB7A",
"RABEP1",
"RABEPK",
"RABGAP1",
"RABGAP1L",
"RABGEF1",
"RABGGTA",
"RABGGTB",
"RABL2A",
"RACGAP1",
"RAD17",
"RAD18",
"RAD21",
"RAD23B",
"RAD50",
"RAD51",
"RAD51B",
"RAD51C",
"RAD52",
"RAD54B",
"RAD54L2",
"RAD9B",
"RAF1",
"RAI14",
"RALA",
"RALB",
"RALBP1",
"RALGAPA1",
"RALGAPA2",
"RALGAPB",
"RALGPS1",
"RALGPS2",
"RALY",
"RANBP10",
"RANBP17",
"RANBP2",
"RANBP3",
"RANBP9",
"RANGAP1",
"RAP1A",
"RAP1B",
"RAP1GAP2",
"RAP1GDS1",
"RAPGEF1",
"RAPGEF5",
"RAPGEF6",
"RAPGEFL1",
"RAPH1",
"RARA",
"RARS",
"RASA1",
"RASA2",
"RASA3",
"RASAL1",
"RASAL2",
"RASGRP1",
"RASSF3",
"RASSF8",
"RAVER2",
"RB1",
"RB1CC1",
"RBAK-LOC389458",
"RBBP4",
"RBBP6",
"RBBP7",
"RBBP8",
"RBFOX2",
"RBL1",
"RBL2",
"RBM14-RBM4",
"RBM17",
"RBM19",
"RBM23",
"RBM25",
"RBM26",
"RBM27",
"RBM28",
"RBM3",
"RBM33",
"RBM34",
"RBM39",
"RBM4",
"RBM41",
"RBM42",
"RBM45",
"RBM47",
"RBM4B",
"RBM5",
"RBM6",
"RBMS1",
"RBMS2",
"RBMXL1",
"RBPJ",
"RBPMS",
"RBX1",
"RC3H1",
"RC3H2",
"RCAN3",
"RCC2",
"RCL1",
"RCN1",
"RCOR1",
"RCOR3",
"RDH11",
"RDX",
"RECK",
"RECQL",
"RECQL4",
"RECQL5",
"REEP3",
"REEP5",
"REL",
"RELB",
"RELL1",
"REPS1",
"REPS2",
"RER1",
"RERE",
"RET",
"RETSAT",
"REV1",
"REV3L",
"REXO4",
"RFC1",
"RFC4",
"RFT1",
"RFWD2",
"RFWD3",
"RFX2",
"RFX3",
"RFX7",
"RGL1",
"RGL3",
"RGNEF",
"RGPD6",
"RGS12",
"RGS3",
"RHBDD1",
"RHEB",
"RHOA",
"RHOBTB2",
"RHOBTB3",
"RHOD",
"RHOT1",
"RHPN2",
"RIC8B",
"RICTOR",
"RIF1",
"RILPL1",
"RIMKLB",
"RIMS2",
"RIN2",
"RINT1",
"RIPK1",
"RIPK2",
"RLF",
"RMND1",
"RMND5A",
"RMND5B",
"RNASEH2A",
"RNASEH2B",
"RNASEH2C",
"RND1",
"RNF10",
"RNF11",
"RNF111",
"RNF114",
"RNF115",
"RNF121",
"RNF123",
"RNF13",
"RNF130",
"RNF138",
"RNF144A",
"RNF145",
"RNF149",
"RNF166",
"RNF168",
"RNF169",
"RNF170",
"RNF19A",
"RNF19B",
"RNF2",
"RNF213",
"RNF214",
"RNF216",
"RNF216P1",
"RNF217",
"RNF219",
"RNF220",
"RNF31",
"RNF32",
"RNF34",
"RNF38",
"RNF4",
"RNF41",
"RNFT2",
"RNGTT",
"RNH1",
"RNPC3",
"RNPEP",
"RNPS1",
"ROBO1",
"ROCK1",
"ROCK2",
"RP2",
"RPA1",
"RPAP1",
"RPAP2",
"RPE",
"RPF2",
"RPGRIP1L",
"RPH3AL",
"RPL10",
"RPL12",
"RPL13",
"RPL13A",
"RPL14",
"RPL17",
"RPL22",
"RPL23A",
"RPL27",
"RPL3",
"RPL30",
"RPL35A",
"RPL4",
"RPL5",
"RPL7A",
"RPL8",
"RPN1",
"RPN2",
"RPPH1",
"RPRD1A",
"RPRD1B",
"RPRD2",
"RPS10-NUDT3",
"RPS13",
"RPS15",
"RPS15A",
"RPS17L",
"RPS19",
"RPS24",
"RPS4X",
"RPS5",
"RPS6",
"RPS6KA1",
"RPS6KA3",
"RPS6KA5",
"RPS6KB1",
"RPS6KC1",
"RPS9",
"RPSA",
"RPTOR",
"RPUSD2",
"RPUSD3",
"RQCD1",
"RRAGB",
"RRAS2",
"RRBP1",
"RREB1",
"RRM1",
"RRM2",
"RRP12",
"RRP1B",
"RRP36",
"RRP7A",
"RSBN1",
"RSBN1L",
"RSF1",
"RSL1D1",
"RSRC1",
"RSRC2",
"RSU1",
"RTCD1",
"RTEL1-TNFRSF6B",
"RTF1",
"RTN3",
"RTN4",
"RTTN",
"RUFY1",
"RUFY2",
"RUFY3",
"RUNDC1",
"RUNX1",
"RUNX2",
"RUSC1",
"RUSC2",
"RUVBL1",
"RUVBL2",
"RWDD2B",
"RXRA",
"RYK",
"S100A10",
"S100A14",
"S100A16",
"S100PBP",
"S1PR2",
"SAAL1",
"SACM1L",
"SACS",
"SAE1",
"SAFB",
"SAFB2",
"SALL4",
"SAMD11",
"SAMD4A",
"SAMD4B",
"SAMD8",
"SAMHD1",
"SAMM50",
"SAP130",
"SAR1A",
"SARS",
"SARS2",
"SART3",
"SASS6",
"SAT1",
"SATB2",
"SAV1",
"SBDS",
"SBF2",
"SBNO1",
"SBNO2",
"SCAF11",
"SCAF4",
"SCAF8",
"SCAI",
"SCAMP1",
"SCAMP2",
"SCAMP4",
"SCAP",
"SCAPER",
"SCARB1",
"SCARB2",
"SCCPDH",
"SCD",
"SCFD1",
"SCFD2",
"SCG5",
"SCLT1",
"SCMH1",
"SCML2",
"SCN8A",
"SCNM1",
"SCNN1A",
"SCP2",
"SCRN1",
"SCYL2",
"SCYL3",
"SDAD1",
"SDC1",
"SDCCAG8",
"SDF4",
"SDHA",
"SDHAF2",
"SDHAP1",
"SDHAP2",
"SDHC",
"SDK1",
"SDSL",
"SEC11A",
"SEC13",
"SEC14L2",
"SEC16A",
"SEC22A",
"SEC22C",
"SEC23A",
"SEC23B",
"SEC23IP",
"SEC24A",
"SEC24B",
"SEC24C",
"SEC24D",
"SEC31A",
"SEC61A1",
"SEC62",
"SEC63",
"SECISBP2",
"SECISBP2L",
"SEH1L",
"SEL1L",
"SEL1L3",
"SEMA3A",
"SEMA3C",
"SEMA3F",
"SEMA4B",
"SEMA4D",
"SEMA5A",
"SENP1",
"SENP2",
"SENP5",
"SENP6",
"SENP7",
"SEPHS1",
"SEPSECS",
"SERBP1",
"SERGEF",
"SERINC2",
"SERINC3",
"SERINC5",
"SERPINB1",
"SERPINB6",
"SERPINB7",
"SERPINE2",
"SERTAD1",
"SESN2",
"SET",
"SETBP1",
"SETD1A",
"SETD2",
"SETD3",
"SETD5",
"SETDB1",
"SETDB2",
"SETX",
"SEZ6L2",
"SF1",
"SF3A1",
"SF3A3",
"SF3B1",
"SF3B14",
"SF3B2",
"SF3B3",
"SFI1",
"SFMBT1",
"SFMBT2",
"SFPQ",
"SFRP1",
"SFSWAP",
"SFT2D2",
"SFXN1",
"SFXN5",
"SGCE",
"SGK196",
"SGMS1",
"SGOL1",
"SGPL1",
"SGSM3",
"SH2B2",
"SH2B3",
"SH2D4A",
"SH3BGRL",
"SH3BGRL2",
"SH3BP1",
"SH3BP2",
"SH3BP4",
"SH3BP5",
"SH3D19",
"SH3GL1",
"SH3GLB1",
"SH3GLB2",
"SH3KBP1",
"SH3PXD2A",
"SH3PXD2B",
"SH3RF1",
"SH3RF3",
"SH3YL1",
"SHANK2",
"SHB",
"SHISA9",
"SHKBP1",
"SHMT1",
"SHOC2",
"SHPK",
"SHPRH",
"SHQ1",
"SHROOM2",
"SHROOM3",
"SIAH2",
"SIDT1",
"SIK3",
"SIL1",
"SIN3A",
"SIN3B",
"SIPA1L1",
"SIPA1L2",
"SIPA1L3",
"SIRT1",
"SIRT3",
"SIRT5",
"SIRT7",
"SKA3",
"SKI",
"SKIV2L2",
"SKP1",
"SLAIN1",
"SLBP",
"SLC10A7",
"SLC11A2",
"SLC12A2",
"SLC12A4",
"SLC12A7",
"SLC12A8",
"SLC12A9",
"SLC15A4",
"SLC16A1",
"SLC16A3",
"SLC16A9",
"SLC17A5",
"SLC19A1",
"SLC19A2",
"SLC1A5",
"SLC20A1",
"SLC20A2",
"SLC22A15",
"SLC22A23",
"SLC23A2",
"SLC24A6",
"SLC25A12",
"SLC25A13",
"SLC25A16",
"SLC25A17",
"SLC25A24",
"SLC25A25",
"SLC25A26",
"SLC25A3",
"SLC25A30",
"SLC25A32",
"SLC25A33",
"SLC25A36",
"SLC25A38",
"SLC25A39",
"SLC25A43",
"SLC25A44",
"SLC26A11",
"SLC26A2",
"SLC27A3",
"SLC27A4",
"SLC27A5",
"SLC29A2",
"SLC2A13",
"SLC30A5",
"SLC30A6",
"SLC30A7",
"SLC30A9",
"SLC33A1",
"SLC35A3",
"SLC35B1",
"SLC35D2",
"SLC35E1",
"SLC35E2",
"SLC35E2B",
"SLC35F2",
"SLC35F5",
"SLC36A1",
"SLC36A4",
"SLC37A3",
"SLC38A1",
"SLC38A10",
"SLC38A2",
"SLC38A6",
"SLC38A7",
"SLC38A9",
"SLC39A10",
"SLC39A11",
"SLC39A6",
"SLC39A8",
"SLC39A9",
"SLC3A2",
"SLC41A1",
"SLC41A2",
"SLC43A1",
"SLC43A3",
"SLC44A1",
"SLC44A2",
"SLC45A4",
"SLC4A2",
"SLC4A7",
"SLC5A3",
"SLC6A6",
"SLC6A9",
"SLC7A1",
"SLC7A11",
"SLC7A2",
"SLC7A5",
"SLC7A6",
"SLC8A1",
"SLC8A3",
"SLC9A1",
"SLC9A2",
"SLC9A3R1",
"SLC9A6",
"SLC9A7",
"SLC9A8",
"SLCO1B3",
"SLCO3A1",
"SLCO4A1",
"SLIT2",
"SLK",
"SLMAP",
"SLMO1",
"SLTM",
"SMAD1",
"SMAD2",
"SMAD3",
"SMAD4",
"SMAD5",
"SMAD6",
"SMAP2",
"SMARCA2",
"SMARCA4",
"SMARCA5",
"SMARCAD1",
"SMARCB1",
"SMARCC1",
"SMARCD1",
"SMARCD2",
"SMARCD3",
"SMC1A",
"SMC3",
"SMC4",
"SMC5",
"SMC6",
"SMCHD1",
"SMCR7L",
"SMEK1",
"SMEK2",
"SMG1",
"SMG5",
"SMG6",
"SMG7",
"SMG9",
"SMNDC1",
"SMO",
"SMOC1",
"SMPD4",
"SMS",
"SMU1",
"SMUG1",
"SMURF1",
"SMURF2",
"SMYD2",
"SMYD3",
"SMYD4",
"SNAP23",
"SNAP29",
"SNAP47",
"SNAPC1",
"SNAPC3",
"SNAPC4",
"SND1",
"SNF8",
"SNHG11",
"SNHG12",
"SNHG3",
"SNRK",
"SNRNP200",
"SNRNP40",
"SNRNP48",
"SNRPA",
"SNRPN",
"SNTB2",
"SNUPN",
"SNW1",
"SNX1",
"SNX11",
"SNX13",
"SNX14",
"SNX19",
"SNX2",
"SNX22",
"SNX25",
"SNX27",
"SNX29",
"SNX3",
"SNX30",
"SNX4",
"SNX5",
"SNX6",
"SNX8",
"SNX9",
"SOAT1",
"SOBP",
"SOCS4",
"SOCS7",
"SOD2",
"SOLH",
"SON",
"SORL1",
"SORT1",
"SOS1",
"SOS2",
"SOX13",
"SOX9",
"SP1",
"SP100",
"SP140L",
"SP2",
"SP3",
"SP4",
"SPAG1",
"SPAG16",
"SPAG5",
"SPAG9",
"SPAST",
"SPATA13",
"SPATA24",
"SPATA5",
"SPATS2",
"SPATS2L",
"SPCS3",
"SPECC1",
"SPECC1L",
"SPEN",
"SPG11",
"SPG20",
"SPG21",
"SPG7",
"SPICE1",
"SPIN1",
"SPIRE1",
"SPIRE2",
"SPOPL",
"SPPL2A",
"SPPL3",
"SPRED1",
"SPRED2",
"SPRYD7",
"SPSB1",
"SPTAN1",
"SPTBN1",
"SPTBN2",
"SPTLC1",
"SPTLC2",
"SPTSSA",
"SQLE",
"SQRDL",
"SQSTM1",
"SRBD1",
"SRC",
"SRCAP",
"SRD5A1",
"SREBF2",
"SREK1",
"SRF",
"SRGAP1",
"SRGAP2",
"SRM",
"SRP54",
"SRP68",
"SRP72",
"SRPK1",
"SRPK2",
"SRPRB",
"SRRM1",
"SRRM2",
"SRRT",
"SRSF1",
"SRSF11",
"SRSF2",
"SRSF3",
"SRSF4",
"SRSF5",
"SRSF6",
"SRSF7",
"SS18",
"SS18L1",
"SSB",
"SSBP2",
"SSFA2",
"SSH1",
"SSH2",
"SSNA1",
"SSR3",
"SSU72",
"ST14",
"ST3GAL1",
"ST3GAL3",
"ST3GAL4",
"ST3GAL5",
"ST6GAL1",
"ST6GALNAC6",
"ST7",
"ST7L",
"ST8SIA6",
"STAC3",
"STAG1",
"STAG2",
"STAM",
"STAM2",
"STAMBP",
"STAMBPL1",
"STARD10",
"STARD13",
"STARD3NL",
"STARD7",
"STARD9",
"STAT2",
"STAT3",
"STAT5B",
"STAU1",
"STAU2",
"STIL",
"STIM1",
"STIM2",
"STIP1",
"STK11",
"STK17A",
"STK17B",
"STK24",
"STK25",
"STK3",
"STK35",
"STK38",
"STK39",
"STK4",
"STK40",
"STOX2",
"STRBP",
"STRN",
"STRN3",
"STT3A",
"STT3B",
"STX12",
"STX16",
"STX17",
"STX5",
"STX6",
"STX8",
"STXBP4",
"STXBP5",
"STXBP6",
"STYX",
"STYXL1",
"SUCLA2",
"SUCLG2",
"SUGP1",
"SUGP2",
"SUGT1",
"SULF2",
"SULT2B1",
"SUMF1",
"SUMF2",
"SUMO3",
"SUN1",
"SUPT16H",
"SUPT5H",
"SUPT6H",
"SUPV3L1",
"SURF4",
"SUSD1",
"SUV39H2",
"SUV420H1",
"SUZ12",
"SVEP1",
"SVIL",
"SWAP70",
"SWT1",
"SYCP2L",
"SYDE2",
"SYMPK",
"SYNCRIP",
"SYNE2",
"SYNGR2",
"SYNJ1",
"SYNJ2",
"SYNJ2BP",
"SYNRG",
"SYPL1",
"SYT1",
"SYT14",
"SYT7",
"SYTL2",
"SYTL5",
"SYVN1",
"SZT2",
"TAB2",
"TAB3",
"TACC1",
"TACC2",
"TACC3",
"TADA1",
"TADA2A",
"TADA2B",
"TAF1",
"TAF11",
"TAF12",
"TAF13",
"TAF1A",
"TAF1B",
"TAF2",
"TAF4",
"TAF4B",
"TAF5",
"TAF5L",
"TAF6",
"TAF6L",
"TAF8",
"TAF9",
"TAGLN2",
"TALDO1",
"TAMM41",
"TANC1",
"TANC2",
"TANK",
"TAOK1",
"TAOK2",
"TAOK3",
"TAPT1",
"TARBP1",
"TARS",
"TARS2",
"TARSL2",
"TAS2R43",
"TASP1",
"TATDN1",
"TATDN2",
"TAX1BP1",
"TBC1D1",
"TBC1D10B",
"TBC1D12",
"TBC1D13",
"TBC1D14",
"TBC1D20",
"TBC1D22A",
"TBC1D23",
"TBC1D24",
"TBC1D2B",
"TBC1D30",
"TBC1D4",
"TBC1D5",
"TBC1D7",
"TBC1D8",
"TBC1D9",
"TBC1D9B",
"TBCCD1",
"TBCD",
"TBCE",
"TBCEL",
"TBCK",
"TBK1",
"TBL1X",
"TBL1XR1",
"TBPL1",
"TBRG4",
"TBX19",
"TBX2",
"TC2N",
"TCEA1",
"TCEA2",
"TCEB3",
"TCERG1",
"TCF12",
"TCF20",
"TCF25",
"TCF3",
"TCF7L2",
"TCFL5",
"TCOF1",
"TCONS_00003998",
"TCONS_00009284",
"TCONS_00010097",
"TCONS_00011149",
"TCONS_00011220",
"TCONS_00012989",
"TCONS_00014744",
"TCONS_00015535",
"TCONS_00017038",
"TCONS_00017391",
"TCONS_00022478",
"TCONS_00022740",
"TCONS_00023880",
"TCONS_00024800",
"TCONS_00025531",
"TCONS_00026319",
"TCONS_00026840",
"TCONS_l2_00001808",
"TCONS_l2_00003636",
"TCONS_l2_00004572",
"TCONS_l2_00007731",
"TCONS_l2_00008016",
"TCONS_l2_00012430",
"TCONS_l2_00015640",
"TCONS_l2_00017148",
"TCONS_l2_00019485",
"TCONS_l2_00022658",
"TCONS_l2_00025633",
"TCONS_l2_00026002",
"TCONS_l2_00026125",
"TCONS_l2_00026190",
"TCONS_l2_00026193",
"TCONS_l2_00026194",
"TCONS_l2_00026196",
"TCONS_l2_00026542",
"TCONS_l2_00026704",
"TCONS_l2_00026952",
"TCONS_l2_00026970",
"TCONS_l2_00027391",
"TCONS_l2_00027397",
"TCONS_l2_00027398",
"TCONS_l2_00028290",
"TCONS_l2_00029068",
"TCONS_l2_00030731",
"TCONS_l2_00030734",
"TCP1",
"TCP11L1",
"TCTN2",
"TCTN3",
"TDP1",
"TDP2",
"TDRD3",
"TEAD1",
"TEAD4",
"TEC",
"TECPR1",
"TECPR2",
"TELO2",
"TEP1",
"TERF2",
"TERT",
"TES",
"TESK2",
"TET1",
"TET2",
"TET3",
"TEX10",
"TEX2",
"TEX261",
"TEX264",
"TEX9",
"TFAP4",
"TFB2M",
"TFCP2",
"TFDP1",
"TFDP2",
"TFE3",
"TFF1",
"TFG",
"TFIP11",
"TFRC",
"TGFA",
"TGFB1",
"TGFB2",
"TGFBI",
"TGFBR1",
"TGFBR2",
"TGFBRAP1",
"TGIF2",
"TGIF2-C20ORF24",
"TGOLN2",
"TGS1",
"THADA",
"THAP4",
"THBS1",
"THG1L",
"THNSL2",
"THOC1",
"THOC2",
"THOC5",
"THOC7",
"THOP1",
"THRAP3",
"THRB",
"THSD1",
"THSD4",
"THUMPD2",
"THUMPD3",
"TIA1",
"TIAL1",
"TIAM1",
"TIAM2",
"TIMELESS",
"TIMM23",
"TIMMDC1",
"TIMP2",
"TINAGL1",
"TIPARP",
"TIPRL",
"TJAP1",
"TJP1",
"TJP2",
"TJP3",
"TK1",
"TKT",
"TLE1",
"TLE4",
"TLK1",
"TLK2",
"TLL1",
"TLN1",
"TLR6",
"TM2D1",
"TM4SF19-TCTEX1D2",
"TM7SF3",
"TM9SF1",
"TM9SF2",
"TM9SF3",
"TM9SF4",
"TMBIM4",
"TMBIM6",
"TMC7",
"TMCC1",
"TMCC2",
"TMCO3",
"TMCO7",
"TMED2",
"TMEFF1",
"TMEM109",
"TMEM11",
"TMEM111",
"TMEM116",
"TMEM120B",
"TMEM128",
"TMEM131",
"TMEM135",
"TMEM138",
"TMEM161B",
"TMEM165",
"TMEM167A",
"TMEM180",
"TMEM181",
"TMEM182",
"TMEM184B",
"TMEM189",
"TMEM189-UBE2V1",
"TMEM192",
"TMEM2",
"TMEM206",
"TMEM209",
"TMEM238",
"TMEM30A",
"TMEM38A",
"TMEM38B",
"TMEM39A",
"TMEM41B",
"TMEM44",
"TMEM45B",
"TMEM48",
"TMEM5",
"TMEM50A",
"TMEM50B",
"TMEM55A",
"TMEM56-RWDD3",
"TMEM57",
"TMEM59",
"TMEM60",
"TMEM62",
"TMEM63B",
"TMEM65",
"TMEM66",
"TMEM67",
"TMEM87A",
"TMEM8A",
"TMEM91",
"TMLHE",
"TMOD2",
"TMOD3",
"TMOD4",
"TMPO",
"TMSB10",
"TMTC1",
"TMTC2",
"TMTC3",
"TMUB2",
"TMX1",
"TMX2",
"TMX2-CTNND1",
"TMX3",
"TNC",
"TNFRSF10B",
"TNFRSF11A",
"TNFRSF1A",
"TNFRSF21",
"TNIK",
"TNIP1",
"TNIP2",
"TNK2",
"TNKS",
"TNKS2",
"TNPO1",
"TNPO2",
"TNPO3",
"TNRC18",
"TNRC6A",
"TNRC6B",
"TNRC6C",
"TNS1",
"TNS3",
"TNS4",
"TOLLIP",
"TOM1",
"TOM1L1",
"TOM1L2",
"TOMM20",
"TOMM70A",
"TOP1",
"TOP2A",
"TOP2B",
"TOP3A",
"TOP3B",
"TOPBP1",
"TOR1B",
"TOX2",
"TOX4",
"TP53BP1",
"TP53BP2",
"TP53I3",
"TPCN1",
"TPCN2",
"TPD52L2",
"TPM1",
"TPM4",
"TPP2",
"TPR",
"TPRN",
"TPST1",
"TPT1",
"TPTE",
"TPX2",
"TRA2A",
"TRA2B",
"TRAF2",
"TRAF3",
"TRAF3IP2",
"TRAF4",
"TRAF5",
"TRAFD1",
"TRAIP",
"TRAK1",
"TRAM1",
"TRAP1",
"TRAPPC10",
"TRAPPC6B",
"TRAPPC8",
"TRAPPC9",
"TRERF1",
"TRIM11",
"TRIM14",
"TRIM16",
"TRIM2",
"TRIM24",
"TRIM25",
"TRIM28",
"TRIM29",
"TRIM33",
"TRIM35",
"TRIM36",
"TRIM37",
"TRIM4",
"TRIM44",
"TRIO",
"TRIP11",
"TRIP12",
"TRIP13",
"TRIP4",
"TRIP6",
"TRIT1",
"TRMT11",
"TRMT1L",
"TRMT2A",
"TRMT2B",
"TRMT61A",
"TRMT61B",
"TRNT1",
"TROAP",
"TROVE2",
"TRPC1",
"TRPC4AP",
"TRPM4",
"TRPM7",
"TRPS1",
"TRPV1",
"TRRAP",
"TSC1",
"TSC2",
"TSEN2",
"TSFM",
"TSG101",
"TSHZ1",
"TSKU",
"TSN",
"TSNARE1",
"TSNAX",
"TSNAX-DISC1",
"TSPAN1",
"TSPAN14",
"TSPAN3",
"TSPO",
"TSSC1",
"TSTD2",
"TTBK2",
"TTC1",
"TTC13",
"TTC15",
"TTC17",
"TTC19",
"TTC21B",
"TTC23",
"TTC26",
"TTC27",
"TTC28",
"TTC3",
"TTC33",
"TTC35",
"TTC37",
"TTC39C",
"TTC7A",
"TTC7B",
"TTC8",
"TTC9C",
"TTF1",
"TTF2",
"TTI1",
"TTL",
"TTLL1",
"TTLL11",
"TTLL12",
"TTLL13",
"TTLL4",
"TTLL5",
"TTPAL",
"TTYH3",
"TUBA1B",
"TUBA1C",
"TUBB4B",
"TUBD1",
"TUBG1",
"TUBGCP2",
"TUBGCP3",
"TUBGCP4",
"TUBGCP5",
"TUFM",
"TUFT1",
"TULP4",
"TUSC3",
"TWF1",
"TXLNA",
"TXLNG",
"TXNDC11",
"TXNDC16",
"TXNL1",
"TXNL4A",
"TXNL4B",
"TXNRD1",
"TXNRD3",
"TYK2",
"TYRO3",
"TYW1",
"TYW1B",
"TYW5",
"U2AF2",
"UACA",
"UAP1",
"UBA1",
"UBA2",
"UBA5",
"UBA6",
"UBAC1",
"UBAC2",
"UBAP1",
"UBAP2",
"UBAP2L",
"UBASH3B",
"UBB",
"UBC",
"UBE2A",
"UBE2C",
"UBE2CBP",
"UBE2D2",
"UBE2D3",
"UBE2E2",
"UBE2E3",
"UBE2F",
"UBE2F-SCLY",
"UBE2G1",
"UBE2I",
"UBE2J2",
"UBE2K",
"UBE2O",
"UBE2Q2",
"UBE2R2",
"UBE2V2",
"UBE2W",
"UBE2Z",
"UBE3A",
"UBE3B",
"UBE3C",
"UBE4A",
"UBE4B",
"UBIAD1",
"UBL3",
"UBL4A",
"UBL7",
"UBLCP1",
"UBN2",
"UBP1",
"UBQLN1",
"UBR1",
"UBR2",
"UBR3",
"UBR4",
"UBR5",
"UBR7",
"UBXN2A",
"UBXN4",
"UBXN7",
"UCHL3",
"UCK2",
"UCKL1",
"UEVLD",
"UFSP2",
"UGCG",
"UGDH",
"UGGT1",
"UGGT2",
"UGP2",
"UHMK1",
"UHRF1",
"UHRF1BP1",
"UHRF1BP1L",
"UHRF2",
"UIMC1",
"ULK2",
"ULK4",
"UMPS",
"UNC119B",
"UNC13B",
"UNC13D",
"UNC45A",
"UNG",
"UNK",
"UNKL",
"UPF2",
"UPF3B",
"UQCC",
"UQCRC2",
"UQCRH",
"URB1",
"URB2",
"URI1",
"UROS",
"USO1",
"USP1",
"USP10",
"USP11",
"USP12",
"USP13",
"USP14",
"USP15",
"USP22",
"USP24",
"USP25",
"USP28",
"USP3",
"USP30",
"USP31",
"USP32",
"USP33",
"USP34",
"USP36",
"USP37",
"USP39",
"USP4",
"USP42",
"USP43",
"USP45",
"USP46",
"USP47",
"USP48",
"USP50",
"USP53",
"USP54",
"USP6NL",
"USP7",
"USP8",
"USP9X",
"USPL1",
"UTP14A",
"UTP18",
"UTP20",
"UTP6",
"UTRN",
"UVRAG",
"UXS1",
"VAC14",
"VAMP3",
"VANGL1",
"VAPA",
"VAPB",
"VASP",
"VAV2",
"VAV3",
"VCL",
"VCP",
"VDAC1",
"VDAC3",
"VDR",
"VEGFC",
"VEPH1",
"VEZF1",
"VEZT",
"VGLL3",
"VIPR2",
"VKORC1",
"VKORC1L1",
"VMP1",
"VOPP1",
"VPRBP",
"VPS11",
"VPS13A",
"VPS13B",
"VPS13C",
"VPS13D",
"VPS18",
"VPS25",
"VPS26A",
"VPS26B",
"VPS33A",
"VPS35",
"VPS36",
"VPS37A",
"VPS37C",
"VPS45",
"VPS4A",
"VPS53",
"VPS54",
"VPS72",
"VPS8",
"VRK1",
"VRK3",
"VSIG10",
"VTA1",
"VTI1A",
"VWA3A",
"VWCE",
"WAC",
"WAPAL",
"WARS",
"WASF2",
"WBSCR16",
"WBSCR22",
"WDFY1",
"WDFY3",
"WDHD1",
"WDPCP",
"WDR1",
"WDR11",
"WDR12",
"WDR17",
"WDR20",
"WDR25",
"WDR26",
"WDR27",
"WDR33",
"WDR34",
"WDR36",
"WDR37",
"WDR4",
"WDR41",
"WDR43",
"WDR44",
"WDR45L",
"WDR47",
"WDR48",
"WDR5",
"WDR52",
"WDR59",
"WDR6",
"WDR60",
"WDR61",
"WDR62",
"WDR66",
"WDR67",
"WDR7",
"WDR70",
"WDR74",
"WDR76",
"WDR78",
"WDR81",
"WDR85",
"WDR89",
"WDR92",
"WDSUB1",
"WDYHV1",
"WFS1",
"WHSC1",
"WHSC1L1",
"WIPF1",
"WIPI1",
"WLS",
"WNK1",
"WNK2",
"WNT3",
"WRB",
"WRN",
"WRNIP1",
"WSB1",
"WSB2",
"WTAP",
"WWC1",
"WWC2",
"WWC3",
"WWOX",
"WWP1",
"WWP2",
"WWTR1",
"XBP1",
"XIAP",
"XPA",
"XPNPEP1",
"XPNPEP3",
"XPO1",
"XPO4",
"XPO5",
"XPO6",
"XPO7",
"XPOT",
"XPR1",
"XRCC1",
"XRCC5",
"XRCC6",
"XRN1",
"XRN2",
"XRRA1",
"XXYLT1",
"XYLB",
"XYLT1",
"XYLT2",
"YAF2",
"YAP1",
"YARS",
"YBEY",
"YEATS2",
"YES1",
"YIPF6",
"YLPM1",
"YME1L1",
"YPEL2",
"YPEL5",
"YTHDC2",
"YTHDF1",
"YTHDF2",
"YTHDF3",
"YWHAB",
"YWHAE",
"YWHAG",
"YWHAQ",
"YWHAZ",
"YY1",
"YY1AP1",
"ZAK",
"ZBTB11",
"ZBTB2",
"ZBTB20",
"ZBTB24",
"ZBTB25",
"ZBTB38",
"ZBTB4",
"ZBTB40",
"ZBTB44",
"ZBTB46",
"ZBTB49",
"ZBTB7A",
"ZBTB8B",
"ZBTB8OS",
"ZC3H11A",
"ZC3H12C",
"ZC3H13",
"ZC3H14",
"ZC3H15",
"ZC3H18",
"ZC3H3",
"ZC3H4",
"ZC3H7A",
"ZC3H7B",
"ZC3HAV1",
"ZC3HC1",
"ZCCHC10",
"ZCCHC11",
"ZCCHC14",
"ZCCHC17",
"ZCCHC2",
"ZCCHC4",
"ZCCHC6",
"ZCCHC7",
"ZCRB1",
"ZDBF2",
"ZDHHC17",
"ZDHHC2",
"ZDHHC20",
"ZDHHC21",
"ZDHHC3",
"ZDHHC4",
"ZDHHC5",
"ZDHHC7",
"ZDHHC8",
"ZDHHC9",
"ZEB1",
"ZER1",
"ZFAND3",
"ZFAND6",
"ZFAT",
"ZFC3H1",
"ZFHX3",
"ZFP106",
"ZFP64",
"ZFP90",
"ZFR",
"ZFX",
"ZFYVE16",
"ZFYVE26",
"ZFYVE27",
"ZFYVE28",
"ZFYVE9",
"ZHX1-C8ORF76",
"ZHX3",
"ZKSCAN1",
"ZMIZ1",
"ZMPSTE24",
"ZMYM1",
"ZMYM2",
"ZMYM3",
"ZMYM4",
"ZMYM5",
"ZMYM6",
"ZMYND11",
"ZMYND8",
"ZNF100",
"ZNF107",
"ZNF12",
"ZNF121",
"ZNF124",
"ZNF131",
"ZNF133",
"ZNF140",
"ZNF141",
"ZNF142",
"ZNF143",
"ZNF148",
"ZNF160",
"ZNF169",
"ZNF175",
"ZNF207",
"ZNF215",
"ZNF217",
"ZNF236",
"ZNF250",
"ZNF252",
"ZNF260",
"ZNF267",
"ZNF276",
"ZNF277",
"ZNF28",
"ZNF280C",
"ZNF280D",
"ZNF282",
"ZNF286A",
"ZNF292",
"ZNF295",
"ZNF3",
"ZNF320",
"ZNF335",
"ZNF337",
"ZNF343",
"ZNF346",
"ZNF358",
"ZNF362",
"ZNF365",
"ZNF367",
"ZNF384",
"ZNF394",
"ZNF395",
"ZNF398",
"ZNF407",
"ZNF410",
"ZNF418",
"ZNF420",
"ZNF44",
"ZNF440",
"ZNF451",
"ZNF460",
"ZNF462",
"ZNF484",
"ZNF496",
"ZNF498",
"ZNF506",
"ZNF512",
"ZNF516",
"ZNF532",
"ZNF551",
"ZNF561",
"ZNF562",
"ZNF565",
"ZNF567",
"ZNF573",
"ZNF577",
"ZNF581",
"ZNF584",
"ZNF585B",
"ZNF586",
"ZNF587",
"ZNF608",
"ZNF609",
"ZNF615",
"ZNF616",
"ZNF622",
"ZNF630",
"ZNF638",
"ZNF644",
"ZNF652",
"ZNF653",
"ZNF670",
"ZNF673",
"ZNF675",
"ZNF678",
"ZNF680",
"ZNF691",
"ZNF7",
"ZNF700",
"ZNF704",
"ZNF706",
"ZNF707",
"ZNF710",
"ZNF717",
"ZNF720",
"ZNF736",
"ZNF738",
"ZNF75A",
"ZNF766",
"ZNF776",
"ZNF780A",
"ZNF780B",
"ZNF782",
"ZNF783",
"ZNF786",
"ZNF79",
"ZNF8",
"ZNF800",
"ZNF81",
"ZNF814",
"ZNF823",
"ZNF827",
"ZNF83",
"ZNF839",
"ZNF841",
"ZNFX1",
"ZNFX1-AS1",
"ZNHIT1",
"ZNHIT6",
"ZNRF3",
"ZP3",
"ZRANB1",
"ZRANB2",
"ZRANB3",
"ZSCAN21",
"ZSWIM6",
"ZUFSP",
"ZW10",
"ZWILCH",
"ZWINT",
"ZXDC",
"ZYG11A",
"ZZEF1",
"ZZZ3"
];

export default AllGeneList;